import {
    room,
    Video,
    CONV_STORAGE,
    socket,
    hideSideMenu,
    stopMediaPlayers,//card 539
    lockFocus,
    kinoTimer,
    convertPath,
    electronConfig,
    timerComponent,
    userPreferences,
    volumeManager,
    cameraOptionsPreferences,
    onStage,
    permissions,
} from '../libs/roomnew';
import axios from 'axios';
import interact from 'interactjs'
import moment from 'moment';
import TimerComponent from '../components/TimerComponent';
// import { forEach } from 'lodash';
import kinoTooltip from './kinoTooltip';
import { getLocalMainKinoTrack } from '../features/base/tracks/functions';
import { setSpacesManagerLobbyVisibleEndpoints, setSpacesManagerVisibleEndpoints } from '../features/base/video-quality/functions';
export default class SplitConversations {
    constructor() {
        // icons
        this.conversationIcon = `<svg width="48px" height="48px" viewBox="0 0 48 48" >
            <g id="group">
                <path d="M0 0L48 0L48 48L0 48L0 0L0 0Z" id="Background" fill="none" stroke="none"></path>
                <path d="M5 10C2.237 10 0 7.762 0 5C0 2.238 2.237 0 5 0C7.761 0 10 2.238 10 5C10 7.762 7.761 10 5 10" transform="translate(7 15)" id="Shape" fill="#FFA726" stroke="none"></path>
                <path d="M0.03 6.104C0.03 6.104 2.768 0 10 0C17.231 0 20.03 6.104 20.03 6.104L20 10L0 10L0.03 6.104ZM44 6C44 6 41.231 0 34 0C26.768 0 24 6 24 6L24 10L44 10L44 6Z" transform="translate(2 27)" id="Shape" fill="#032836" fill-rule="evenodd" stroke="none"></path>
                <path d="M18 6C18 9.315 15.314 12 12 12C8.686 12 6 9.315 6 6C6 2.685 8.686 0 12 0C15.313 0 18 2.686 18 6ZM24 22C24 22 20.614 15.054 11.935 15.054C3.256 15.054 0 22 0 22L0 27L24 27L24 22Z" transform="translate(12 11)" id="Shape" fill="#4d7f91" fill-rule="evenodd" stroke="none"></path>
                <path d="M5 10C7.762 10 10 7.762 10 5C10 2.238 7.762 0 5 0C2.238 0 0 2.238 0 5C0 7.762 2.238 10 5 10" transform="translate(31 15)" id="Shape" fill="#FFA726" stroke="none"></path>
                <path d="M5 10C2.237 10 0 7.762 0 5C0 2.238 2.237 0 5 0C7.761 0 10 2.238 10 5C10 7.762 7.761 10 5 10ZM29 10C31.762 10 34 7.762 34 5C34 2.238 31.762 0 29 0C26.238 0 24 2.238 24 5C24 7.762 26.238 10 29 10Z" transform="translate(7 15)" id="Shape" fill="#032836" fill-rule="evenodd" stroke="none"></path>
            </g>
            </svg>`;
        this.checkIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 191.667 191.667" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g>
            <path xmlns="http://www.w3.org/2000/svg" d="M95.833,0C42.991,0,0,42.99,0,95.833s42.991,95.834,95.833,95.834s95.833-42.991,95.833-95.834S148.676,0,95.833,0z   M150.862,79.646l-60.207,60.207c-2.56,2.56-5.963,3.969-9.583,3.969c-3.62,0-7.023-1.409-9.583-3.969l-30.685-30.685  c-2.56-2.56-3.97-5.963-3.97-9.583c0-3.621,1.41-7.024,3.97-9.584c2.559-2.56,5.962-3.97,9.583-3.97c3.62,0,7.024,1.41,9.583,3.971  l21.101,21.1l50.623-50.623c2.56-2.56,5.963-3.969,9.583-3.969c3.62,0,7.023,1.409,9.583,3.969  C156.146,65.765,156.146,74.362,150.862,79.646z" fill="#022735" data-original="#000000" style="" class=""/>
            </g></svg>`;
        this.errorIcon = `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 15.5H13V17.5H11V15.5ZM11 7.5H13V13.5H11V7.5ZM11.99 2.5C6.47 2.5 2 6.98 2 12.5C2 18.02 6.47 22.5 11.99 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 11.99 2.5ZM12 20.5C7.58 20.5 4 16.92 4 12.5C4 8.08 7.58 4.5 12 4.5C16.42 4.5 20 8.08 20 12.5C20 16.92 16.42 20.5 12 20.5Z" fill="#FF3D00"/></svg>`;
        this.enabled = false;
        this.btnLabel = `Spaces Manager`;
        this.btn = null;
        // this.conversationInputField = $('#auto-conversations-input');                // card 539
        this.modal = $("#splitToConvo");
        this.addConversation = $("#add-split-conversation");
        this.splitConvoContainerText = $('#container-split-convo-placeholder');
        this.conversationsContainer = $("#conversation-list");                          // card 539
        this.manualConversations = {};
        this.numberOfParticipants = $("#split-kino-participants-number");
        this.automaticCalculated = $('#auto-convo-calc');
        this.autoConversationsInput = $('#auto-conversations-input');
        this.runSplitBtn = $("#run-spilt-conversations");
        this.lockFocusAuto = $('#split-auto-lock-focus-checkbox');
        this.lockFocusManual = $('#split-manual-lock-focus-checkbox');
        this.backgroundNoiseAutomatic = $('#background-noise-automatic-checkbox');
        this.backgroundNoiseManual = $('#background-noise-manual-checkbox');
        this.lockMasterVolumeAutomatic = $('#lock-master-volume-automatic');
        this.lockMasterVolumeManual = $('#lock-master-volume-manual');
        this.lockMasterVolumeAutomaticVisibility = $('#lock-master-volume-automatic-visibility');
        this.lockMasterVolumeManualVisibility = $('#lock-master-volume-manual-visibility');
        this.focusLocked=false;
        this.unlockFocusBtn=null;
        this.focusedIcon = `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px">
            <path fill="#032836" d="M12,2c-4.2,0-8,3.22-8,8.2c0,3.18,2.45,6.92,7.34,11.22c0.36,0.32,0.97,0.32,1.33,0C17.55,17.12,20,13.38,20,10.2 C20,5.22,16.2,2,12,2z M7.69,12.49C8.88,11.56,10.37,11,12,11s3.12,0.56,4.31,1.49C15.45,13.98,13.85,15,12,15 S8.55,13.98,7.69,12.49z M12,6c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C10,6.9,10.9,6,12,6z"/>
        </svg>`;
        this.step = 25;
        this.scrolling = false;
        this.initialized=false;
        this.lastAutoSplitSpaces={};
        this.recentUserSpace={};
        this.currentSplitedSpaces={};
        this.moveAllToLobbyBtn = $('#move-all-to-lobby-split-conversation');
        this.closeMoveToSpaces = $('#close-move-to-spaces');
        this.cancelMoveToSpaces = $('#cancel-move-to-spaces');
        this.moveOptionsAuto = $('#move-options-auto');
        this.moveOptionsManually = $('#move-options-manually');

        //notifications
        this.warnNotificationAutoSwitch = $('#warn-before-split-automatic-checkbox');
        this.warnNotificationManualSwitch = $('#warn-before-split-manual-checkbox');
        this.playNotificationAutoSwitch = $('#play-notification-sound-automatic-checkbox');
        this.playNotificationManualSwitch = $('#play-notification-sound-manual-checkbox');
        this.playNotificationAutoVisibility = $('#play-notification-sound-automatic-visibility');
        this.playNotificationManualVisibility = $('#play-notification-sound-manual-visibility');
        this.warnNotificationAuto = false;
        this.warnNotificationManual = false;
        this.playNotificationAuto = false;
        this.playNotificationManual = false;

        //repeat
        this.autoRepeatCheckBox=$("#split-auto-repeat-enabled");
        this.repeatOccurMinutes=$("#repeat-occur-minutes");
        this.repeatOccurSeconds=$("#repeat-occur-seconds");
        this.repeatRunEndsInput=$("#repeat-run-ends-input");
        this.repeatRunLabel=$("#repeat-runs-text");
        this.recurring=null;
        this.lobbyContainerManually = $('#spl-participant-list');
        this.setBackgroundNoiseAutomatic = false;
        this.setBackgroundNoiseManual = false;
        this.minimizedIcon=`<svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M35.0013 72.9167C26.9426 72.9167 20.418 66.3892 20.418 58.3333C20.418 50.2775 26.9426 43.75 35.0013 43.75C43.0542 43.75 49.5846 50.2775 49.5846 58.3333C49.5846 66.3892 43.0542 72.9167 35.0013 72.9167Z" fill="#C4C4C4"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.91953 96.5533C5.91953 96.5533 13.9054 78.75 34.9987 78.75C56.0891 78.75 64.2529 96.5533 64.2529 96.5533L64.1654 107.917H5.83203L5.91953 96.5533ZM134.165 96.25C134.165 96.25 126.089 78.75 104.999 78.75C83.9054 78.75 75.832 96.25 75.832 96.25V107.917H134.165V96.25Z" fill="#C4C4C4"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M87.5 49.584C87.5 59.2527 79.6658 67.084 70 67.084C60.3342 67.084 52.5 59.2527 52.5 49.584C52.5 39.9152 60.3342 32.084 70 32.084C79.6629 32.084 87.5 39.9182 87.5 49.584ZM105 96.2507C105 96.2507 95.1242 75.9915 69.8104 75.9915C44.4967 75.9915 35 96.2507 35 96.2507V110.834H105V96.2507Z" fill="#F8F8F8"/>
        <path d="M105.001 72.9167C113.057 72.9167 119.585 66.3892 119.585 58.3333C119.585 50.2775 113.057 43.75 105.001 43.75C96.9455 43.75 90.418 50.2775 90.418 58.3333C90.418 66.3892 96.9455 72.9167 105.001 72.9167Z" fill="#C4C4C4"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M35.0013 72.9167C26.9426 72.9167 20.418 66.3892 20.418 58.3333C20.418 50.2775 26.9426 43.75 35.0013 43.75C43.0542 43.75 49.5846 50.2775 49.5846 58.3333C49.5846 66.3892 43.0542 72.9167 35.0013 72.9167ZM105.001 72.9167C113.057 72.9167 119.585 66.3892 119.585 58.3333C119.585 50.2775 113.057 43.75 105.001 43.75C96.9455 43.75 90.418 50.2775 90.418 58.3333C90.418 66.3892 96.9455 72.9167 105.001 72.9167Z" fill="#C4C4C4"/>
        </svg>`;
        this.repeatMinutesSecondsLabel=$("#minutes-seconds-timer");
        this.automaticTimerComponent=new TimerComponent();
        this.manualSplitTimerComponent= new TimerComponent();
        this.automaticPreferences={};
        this.manualPreferences={};
        this.btnClicks=0;
        this.btnClickReset=0;

        this.manualMakePrivateCheckbox=$("#spaces-private-manual-checkbox");
        this.autoMakePrivateCheckbox=$("#spaces-private-auto-checkbox");

        this.settignsCountDown=0;
        this.countDownTimeout=0;

    };

    onLoad() {
        console.log("Loaded")
    };

    events() {
        var sc = this;

        sc.modal.on('keyup',function(e){
            if (e.keyCode == 27) {
                sc.hideModal();
             }
        });

        this.automaticTimerComponent.renderTimerComponent(sc.moveOptionsAuto);
        this.manualSplitTimerComponent.renderTimerComponent(sc.moveOptionsManually);
        userPreferences.registerFeatureHandler('move_to_spaces_auto',(preferences)=>{
            if(!sc.isModerator()){return}
            // console.log(`Received pull focus preferences ${typeof preferences}`,preferences);
            if(typeof preferences == 'object' && Object.keys(preferences).length > 0){
                sc.automaticPreferences=preferences;
                sc.onAutomaticPreferencesLoaded();
            }
        });

        userPreferences.registerFeatureHandler('move_to_spaces_manual',(preferences)=>{
            if(!sc.isModerator()){return}
            // console.log(`Received pull focus preferences ${typeof preferences}`,preferences);
            if(typeof preferences == 'object' && Object.keys(preferences).length > 0){
                sc.manualPreferences=preferences;
                sc.onManualPreferencesLoaded();
            }
        });

        this.addConversation.on('click', ()=>this.newConversationElement());
        this.splitConvoContainerText.on('click',()=>this.newConversationElement());
        this.autoConversationsInput.on('change keydown keyup paste', function() {
            console.log("calculating", $(this).val());
            sc.validateSplit($(this).val());
        });
        $("#minimize-move-to_spaces").on('click', function(){
            Video.minimizedContent.minimizeModal('splitToConvo',sc.minimizedIcon)
        });
        this.handleSearchExludeInput();
        this.runSplitBtn.on('click', e => {
            e.preventDefault();
            sc.btnClicks++;
            console.log("Button clicks",sc.btnClicks);
            sc.disableModalButton(true);
            if(sc.btnClicks==1){
                 let selectedSplitType = null;
                sc.setManualTabMessage("");
                if ($("#pills-automatic-tab").hasClass('active')) {
                    selectedSplitType = 'auto';
                } else if ($("#pills-manual-tab").hasClass('active')) {
                    selectedSplitType = 'manual';
                }

                if (selectedSplitType == 'auto') {
                    sc.automaticSplitConvos();
                } else {
                    sc.manualSplitToConvos();
                }
                sc.btnClickReset=setTimeout(() => {
                    sc.btnClicks=0;
                }, 3000);
            }
        });
        socket.events.splitConversationInvite = (message)=>{
            clearInterval(this.settignsCountDown);
            clearInterval(CONV_STORAGE.countDownInterval);
            $(".notificationContent.JOIN_SPLIT_CONVERSATION_FORCE").remove();
            if(CONV_STORAGE.spacesLoading){
                setTimeout(() => {
                    sc.splitToSpacesInvite(message);
                }, 2500);
            }else{
                sc.splitToSpacesInvite(message);
            }
        };
        socket.events.splitConversationLockMessage=(message)=>{
            if(message.data.lockFocus && !sc.focusLocked){
               //sc.showUnlockFocusButton();
               if(HOST==1 || ROLE=='moderator'){
                 room.setLocalParticipantProperty('can_unlock_spaces',true);
               }
            }

        };

        socket.events.unlockSplitConvosFocus = (message) => this.unlockFocusEvent(message)
        socket.events.splitOutOfSpace = (message) => {
            clearInterval(this.settignsCountDown);
            clearInterval(CONV_STORAGE.countDownInterval);
            $(".notificationContent.JOIN_SPLIT_CONVERSATION_FORCE").remove();
            if(CONV_STORAGE.spacesLoading){
                setTimeout(() => {
                    this.sendMeOutOfSpace(message);
                }, 2500);
            }else{
                this.sendMeOutOfSpace(message);
            }
        };
        //card id 539 begin
        this.autoConversationsInput.on('input paste', function(){
            var maxLength = 5;
            var nonNumReg = /[^0-9]/g
            $(this).val($(this).val().replace(nonNumReg, ''));
            if(this.value.length > maxLength){
                this.value = this.value.substring(0 , maxLength);
            }
        });
        //card id 539 end
        sc.autoRepeatCheckBox.on('change', function(){
            if($(this).is(':checked')){
                $('#repeat-split-container').css("opacity",'1')
                $('#repeat-split-container').find('input').removeAttr('readonly');
                $('#repeat-split-container').addClass('show');
                $('#move-options-auto-showTimerSwitchInput').prop('checked',false).trigger('change');
            }else{
                $('#repeat-split-container').css("opacity",'0.4')
                $('#repeat-split-container').find('input').attr('readonly',true);
                $('#repeat-split-container').removeClass('show');
            }
            sc.validateSplit(sc.autoConversationsInput.val());
        })
        sc.manualMakePrivateCheckbox.on('change',function(){
            if($(this).is(':checked')){
                sc.makeAllSpacesPrivate(true);
            }else{
                sc.makeAllSpacesPrivate(false);
            }
        });
        //on modal close
        // sc.closeMoveToSpaces.on('click keyup', function(){
        //     sc.resetModalUponExit();
        // });
        // sc.cancelMoveToSpaces.on('click keyup', function(){
        //     sc.resetModalUponExit();
        // });

          this.initializeDragDrop();
        $('#pills-manual-tab').on('click', e => this.manualTabClickHandler(e))
        $('#pills-automatic-tab').on('click', e => this.automaticTabClickHandler(e))


        $('.scrollUp').bind("click", function(event) {
            event.preventDefault();
        }).on('mouseover', function(e){
            sc.scrolling = true;
            sc.scrollContent("up")
        }).on('mouseout', function(e){
            sc.scrolling = false;
        })

        $('.scrollDown').bind("click", function(event) {
            event.preventDefault();
        }).on('mouseover', function(e){
            sc.scrolling = true;
            sc.scrollContent("down");
        }).on('mouseout', function(e){
            sc.scrolling = false;
        })
        // end card 539

        sc.moveAllToLobbyBtn.on('click', function(){
            sc.moveAllToLobby();
        })

        sc.backgroundNoiseAutomatic.on('change', function(){
            if($(this).is(':checked')){
                sc.setBackgroundNoiseAutomatic = true;
                sc.lockMasterVolumeAutomaticVisibility.addClass('height');
            }else{
                sc.setBackgroundNoiseAutomatic = false;
                sc.lockMasterVolumeAutomaticVisibility.removeClass('height');
                sc.lockMasterVolumeAutomatic.prop('checked', false);
            }
        });

        sc.backgroundNoiseManual.on('change', function(){
            if($(this).is(':checked')){
                sc.setBackgroundNoiseManual = true;
                sc.lockMasterVolumeManualVisibility.addClass('height');
            }else{
                sc.setBackgroundNoiseManual = false;
                sc.lockMasterVolumeManualVisibility.removeClass('height');
                sc.lockMasterVolumeManual.prop('checked', false);
            }
        });
        // notification events

        sc.warnNotificationAutoSwitch.on('change', function(){
            if($(this).is(':checked')){
                sc.playNotificationAutoSwitch.removeAttr('disabled')
                sc.warnNotificationAuto = true;
                sc.playNotificationAutoVisibility.addClass('height');
            }else{
                sc.warnNotificationAuto = false;
                sc.playNotificationAutoSwitch.prop({'disabled': true, 'checked': false})
                sc.playNotificationAuto = false;
                sc.playNotificationAutoVisibility.removeClass('height');
            }
        });
        sc.warnNotificationManualSwitch.on('change', function(){
            if($(this).is(':checked')){
                sc.playNotificationManualSwitch.removeAttr('disabled')
                sc.warnNotificationManual = true;
                sc.playNotificationManualVisibility.addClass('height');
            }else{
                sc.warnNotificationManual = false;
                sc.playNotificationManualSwitch.prop({'disabled': true, 'checked': false})
                sc.playNotificationManual = false;
                sc.playNotificationManualVisibility.removeClass('height');
            }
        });
        sc.playNotificationAutoSwitch.on('change', function(){
            if($(this).is(':checked')){
                sc.playNotificationAuto = true;
            }else{
                sc.playNotificationAuto = false;
            }
        });
        sc.playNotificationManualSwitch.on('change', function(){
            if($(this).is(':checked')){
                sc.playNotificationManual = true;
            }else{
                sc.playNotificationManual = false;
            }
        });
        //repeat minutes input validation
        sc.repeatOccurMinutes.on('input paste change',function(e){
            $(this).val(sc.validateTimeInput(e.currentTarget.value));
            if(parseInt($(this).val()) > 0){
                sc.repeatMinutesSecondsLabel.html('minutes');
            }else{
                sc.repeatMinutesSecondsLabel.html('seconds');
            }
            sc.validateSplit(sc.autoConversationsInput.val());
        }).on('blur', function(e){
            $(this).val(sc.validateTimeInput(e.currentTarget.value));
            if(parseInt($(this).val()) > 0){
                sc.repeatMinutesSecondsLabel.html('minutes');
            }else{
                sc.repeatMinutesSecondsLabel.html('seconds');
            }
            sc.validateSplit(sc.autoConversationsInput.val());
        }).on('keydown', function(e){
            $(this).val(sc.validateTimeInput(e.currentTarget.value));
            if(parseInt($(this).val()) > 0){
                sc.repeatMinutesSecondsLabel.html('minutes');
            }else{
                sc.repeatMinutesSecondsLabel.html('seconds');
            }
        });
        sc.repeatOccurSeconds.on('input paste change',function(e){
            $(this).val(sc.validateTimeInput(e.currentTarget.value));
            sc.validateSplit(sc.autoConversationsInput.val());
        }).on('blur', function(e){
            $(this).val(sc.validateTimeInput(e.currentTarget.value));
            sc.validateSplit(sc.autoConversationsInput.val());
        }).on('keydown', function(e){
            $(this).val(sc.validateTimeInput(e.currentTarget.value));
        });

        sc.repeatRunEndsInput.on('input paste change',function(e){
            $(this).val(sc.validateRepeatsInput(e.currentTarget.value));
            sc.validateSplit(sc.autoConversationsInput.val());
        }).on('blur', function(e){
            $(this).val(sc.validateRepeatsInput(e.currentTarget.value));
            sc.validateSplit(sc.autoConversationsInput.val());
        }).on('keydown', function(e){
            $(this).val(sc.validateRepeatsInput(e.currentTarget.value));
        });

        $("#pills-manual .accordion-container-split-convo").on("scroll",Video.efss.inViewportSpaceManager.bind(Video.efss,true));
        $("#spl-participant-list").on("scroll",Video.efss.inViewportSpaceManagerLobby.bind(Video.efss,false));

        this.modal.on('hidden.bs.modal', function (e) {
            console.log("Spaces manager modal closed")
            sc.stopEfss();
          })

    };

    stopEfss(){
        setSpacesManagerVisibleEndpoints([])
        setSpacesManagerLobbyVisibleEndpoints([])
    }

    startEfss(){
        Video.efss.inViewportSpaceManager(false);
        Video.efss.inViewportSpaceManagerLobby(false);
    }

    splitToSpacesInvite(message){
        let sc=this;
        console.error("SPLIT DATA INFO: ",message.data);

        if (message.data.inviteType == 'invite') {
            if(message.data.conversation_id!=CONV_STORAGE.myConversation){
                CONV_STORAGE.showNotification(Video.conversationIcon, "JOIN_SPLIT_CONVERSATION_INVITE", message.data);
            }
        } else {

            if(message.data.conversation_id!=CONV_STORAGE.myConversation){
                CONV_STORAGE.showNotification(Video.conversationIcon, "JOIN_SPLIT_CONVERSATION_FORCE", message.data);
            }else{
                // CONV_STORAGE.showNotification(Video.conversationIcon,"SPLIT_SPACES_SETTINGS_CHANGED", message.data);
                sc.splitSpacesSettingsHandler(message.data);
            }
        }
    };

    validateTimeInput(input){
        let number=parseInt(input);
        if(isNaN(number) || number <= 0){
            return '00';
        }
        if(number > 59){
            return 59
        }
        if(number <= 9){return '0'+number}
        return number;
    };
    validateRepeatsInput(input){
        let number=parseInt(input);
        if(isNaN(number) || number < 0){
            return 0;
        }
        if(number > 50){return 50}
        // console.log("Validating repeats input:"+input+" returns ",number);
        return number;
    }
    addOptionButton() {
        var sc = this;
        sc.enabled = true;
        if (sc.btn !== null) {
            return
        }

        const hasAccess=permissions.hasSpacesManager();
        if(!hasAccess && !permissions.isWorkspace){
            return
        }
        sc.optionIcon = $('<div/>', {
            class: "option-icon",
            id: "splitConversationIcon",
            html: sc.conversationIcon,
        });
        sc.optionName = $('<div/>', {
            class: "option-name",
            id: "option-name-split-conversation",
            html: sc.btnLabel,
        });
        sc.optionAction = $('<div/>', {
            class: "option-action",
            id: "option-action-split-conversation",
            html: '',
        });
        sc.optionDescription = $('<div/>', {
            class: "option-description",
            html: [ sc.optionName, sc.optionAction],
        });
        sc.btn = $('<div/>', {
            class: `option ${!hasAccess ? 'feature-disabled': ''}`,
            id: 'splitConversations',
            html: [sc.optionIcon, sc.optionDescription],
        }).on('click', function() {
            if(!hasAccess){return}
            if (sc.enabled) {
                sc.showModal();
            }
            hideSideMenu();
        });
        if(!hasAccess){
            sc.btn.attr('data-toggle','tooltip')
            sc.btn.attr('data-placement','top')
            sc.btn.attr('data-original-title','This feature is disabled in this workspace.')
        }

        $("#option-list").find("#splitConversations").remove();
        $("#option-list").append(sc.btn);

    };

    removeOptionButton() {
        var sc = this;
        sc.enabled = false;
        if (sc.btn !== null) {
            sc.btn.remove();
        }
        sc.btn = null;
        sc.hideModal();
        $("#option-list").find("#splitConversations").remove();
    };
    showModal() {

        if(this.modal.hasClass('minimized-modal')){
            Video.minimizedContent.maximizeModal('splitToConvo');
            setTimeout(() => {
                this.startEfss();
            }, 500);
            return
        }
        this.resetSelections();
        this.resetExcludeInputs();
        this.showNumberOfParticipants();
        this.setManualTabMessage("");
        // this.enableModalButton();
        this.validateSplit(this.autoConversationsInput.val());
        this.addHelpTextIfNoConvo();
        this.addConversations();
        //begin card 539
        if($('#pills-manual-tab').hasClass('active')){
            this.manualTabClickHandler.call(this,false);
        }
        //end card 539
        console.warn("Non space participants:",this.getNonConvoParticipnats());
        this.setModalPermissions();
        this.modal.modal('show');
    };

    isManualSplitVisible(){
        const modalOpen = this.modal.hasClass('show');
        const isManualTabActive = $('#pills-manual-tab').hasClass('active');
        return modalOpen && isManualTabActive;
    }

    setModalPermissions(){
        if(!permissions.hasSpacesLock()){
            this.lockFocusAuto.prop({disabled:true})
            this.lockFocusAuto.closest('.kino-toggle')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('data-original-title','This feature is disabled in this workspace.')
            this.lockFocusManual.prop({disabled:true})
            this.lockFocusManual.closest('.kino-toggle')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('data-original-title','This feature is disabled in this workspace.')
        }

        if(!permissions.hasKinoTimer()){
            this.automaticTimerComponent.setEnabled(false);
            this.manualSplitTimerComponent.setEnabled(false);
        }

        // if(!permissions.hasPrivateSpaces()){
        //     this.autoMakePrivateCheckbox.prop({disabled:true,checked:false});
        //     this.autoMakePrivateCheckbox.closest('.kino-toggle')
        //     .attr('data-toggle','tooltip')
        //     .attr('data-placement','top')
        //     .attr('data-original-title','This feature is disabled in this workspace.')
        //     this.manualMakePrivateCheckbox.prop({disabled:true,checked:false});
        //     this.manualMakePrivateCheckbox.closest('.kino-toggle')
        //     .attr('data-toggle','tooltip')
        //     .attr('data-placement','top')
        //     .attr('data-original-title','This feature is disabled in this workspace.')
        // }
        if(!permissions.hasMuteChatter()){
            this.backgroundNoiseAutomatic.prop({disabled:true});
            this.backgroundNoiseAutomatic.closest('.kino-toggle')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('data-original-title','This feature is disabled in this workspace.')
            this.backgroundNoiseManual.prop({disabled:true});
            this.backgroundNoiseManual.closest('.kino-toggle')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('data-original-title','This feature is disabled in this workspace.')
        }
        if(!permissions.hasChatterLock()){
            this.lockMasterVolumeAutomatic.prop({disabled:true})
            this.lockMasterVolumeAutomatic.closest('.kino-toggle')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('data-original-title','This feature is disabled in this workspace.')
            this.lockMasterVolumeManual.prop({disabled:true})
            this.lockMasterVolumeManual.closest('.kino-toggle')
            .attr('data-toggle','tooltip')
            .attr('data-placement','top')
            .attr('data-original-title','This feature is disabled in this workspace.')
        }
        if(permissions.isWorkspace){
            this.backgroundNoiseAutomatic.prop({checked:permissions.kinoChatterMuteState()}).trigger('change');
            this.backgroundNoiseManual.prop({checked:permissions.kinoChatterMuteState()}).trigger('change');

            this.lockMasterVolumeAutomatic.prop({checked:permissions.kinoChatterLockState()}).trigger('change')
            this.lockMasterVolumeManual.prop({checked:permissions.kinoChatterLockState()}).trigger('change')

            this.lockFocusAuto.prop({checked:permissions.kinoSpacesLockState()}).trigger('change')
            this.lockFocusManual.prop({checked:permissions.kinoSpacesLockState()}).trigger('change')
        }
    }

    hideModal() {
        this.modal.modal('hide');
    }
    unfocusAll() {
        if (Object.keys(Video.focused).length > 0) {
            $.each(Video.focused, function(pid) {
                Video.videos[pid].focusButton.removeClass('active');
                // Video.videos[pid].focusButton.attr('title', 'Focus');
                // Video.videos[pid].focusButton.attr('data-original-title', 'Focus');
                Video.unFocusVideo(pid, false);
            });
        }
    };
    validateSplit(convos) {
        var sc = this;
        convos = parseInt(convos);
        // console.log(`Convos given ,Auto repeat checked ${sc.autoRepeatCheckBox.is(':checked')}`, convos);
        let kinoparticipants = sc.getKinoParticipantIds(true);
        if (kinoparticipants.length <= 1) {
            sc.automaticCalculated.html(`<div class='errors'>${sc.showErrorMessage('Not enough participants to move')}</div>`);
            sc.disableModalButton(false);
            return false;
        }
        if (convos <= 0 || isNaN(convos)) {
            sc.automaticCalculated.html(`<div class='errors'>${sc.showErrorMessage("At least one space needs to be created")}</div>`);
            sc.disableModalButton(false);
            return false;
        }

        let participantsPerKino = Math.floor(kinoparticipants.length / convos);
        if (participantsPerKino < 2) {
            sc.automaticCalculated.html(`<div class='errors'>${sc.showErrorMessage('Can\'t create spaces with less than two participants')}</div>`);
            sc.disableModalButton(false);
            return false;
        }

        if(sc.autoRepeatCheckBox.is(':checked')){
            if(this.automaticTimerComponent.isShown()){
                this.automaticTimerComponent.showTimesUpInput.prop('checked',false).trigger('change');
            }
            if(!sc.validateRepeatTimerInput()){
                sc.disableModalButton(false);
                return false;
            }
        }
        sc.automaticCalculated.html(`<div class='errors'>${sc.showErrorMessage(`Will move ${kinoparticipants.length} participants into ${convos} ${convos==1 ?'space' : 'spaces'} ${ convos > 1 ? `with ${participantsPerKino} participants each` : ''}`,true)}</div>`);
        sc.enableModalButton();
        return true;

    };
    validateManualSplit() {
        var sc = this;
        //let participants = sc.getKinoParticipantIds();
        let convosCreated = Object.keys(sc.manualConversations).length;
        if (convosCreated == 0) {
            sc.setManualTabMessage(`<div class='errors'>${sc.showErrorMessage("At least one space needs to be created")}</div>`);
            sc.disableModalButton(false)
            return false;
        }
        let lessThanMinParticipants = false;
        /*Object.values(sc.manualConversations).map(convo => {
            if (!lessThanMinParticipants) {
                if (convo.participants.length <= -1) {
                    lessThanMinParticipants = true;
                    sc.setManualTabMessage(`Can't split <b>${convo.name}</b> with less than two participants`);
                    return false;
                }
            }
        });*/
        return !lessThanMinParticipants ? true : false;

    };
    async automaticSplitConvos() {
        let sc = this;
        let maxConvos = parseInt(sc.autoConversationsInput.val());
        console.log("Automatic split to spaces existing Spaces",sc.getExistingPinnedSpaceIds());
        //return;
        if (isNaN(maxConvos)) {
            sc.automaticCalculated.html(`<div class='errors'>${sc.showErrorMessage("Please specify a number of spaces to be created")}</div>`);
            sc.enableModalButton();//card 539 #18
            return;
        }
        if (!sc.validateSplit(maxConvos)) {
            sc.enableModalButton();
            return;
        }
        if(this.automaticTimerComponent.isShown()){
            if(!this.automaticTimerComponent.validateTimer()){
                sc.enableModalButton();
                return;
            }
        }
        let participants = sc.getKinoParticipantIds(true);
        let allParticipants = sc.getKinoParticipantIds(false);
        let spaces = sc.splitArray(participants, maxConvos);
        console.log("Shared participants to spaces",spaces);
        let dataToSend = [];
        let inviteType = 'force';
        let setLockFocus = $('#split-auto-lock-focus-checkbox').is(":checked") ? true : false;
        let masterVolume = inviteType == "force" && sc.setBackgroundNoiseAutomatic ? 0 : 0.05;
        let localConvos=Object.keys(spaces).filter(spaceId=>spaceId.toString().startsWith('conversation'));
        let existingConvos=Object.keys(spaces).filter(spaceId=>!spaceId.toString().startsWith('conversation'));
        let makeSpacesPrivate = sc.autoMakePrivateCheckbox.is(":checked");
        let warn = sc.warnNotificationAuto;
        let notificationSound = sc.playNotificationAuto;
        let recurring=sc.autoRepeatCheckBox.is(':checked');
        let timeout = warn ? 10000 : 0;
        let lockMasterVolume = masterVolume == 0 && sc.lockMasterVolumeAutomatic.is(':checked');


        console.log(`Local spaces to create`,localConvos);
        console.log(`Existing spaces to send`,existingConvos);
        if(sc.recurring && sc.recurring.runingTimerId){
            sc.stopRecurringSplit();
        }
        if(recurring){
            //repeat is enabled
            sc.setRecurring();
        }
        //release focus
         if(onStage.isActive()){
             onStage.sendEndOnStage();
         }
         sc.setNewAutomaticPreferences({
            lockFocus:setLockFocus,
            inviteType:inviteType,
            muteChatter:masterVolume===0 ? true : false,
            warnNotification:warn,
            playNotificationSound:notificationSound,
            makeSpacesPrivate:makeSpacesPrivate,
            recurring:recurring ? {
                minutes:parseInt(this.repeatOccurMinutes.val()),
                seconds:parseInt(this.repeatOccurSeconds.val()),
                repeatRuns:parseInt(this.repeatRunEndsInput.val())
            }: false,
            lockMasterVolume: lockMasterVolume,
            timer: {
                showTimer: sc.automaticTimerComponent.isShown() ? true : false,
                showNotification: sc.automaticTimerComponent.showTimesUpInput.is(':checked') ? true : false,
                notificationShowTimeMinutes: sc.automaticTimerComponent.notificationTimeInputMinutes.val(),
                notificationShowTimeSeconds: sc.automaticTimerComponent.notificationTimeInputSeconds.val(),
                playNotificationSound: sc.automaticTimerComponent.playSoundCountdownInput.is(':checked'),
                minutes:sc.automaticTimerComponent.min,
                seconds:sc.automaticTimerComponent.sec
            },
            convosToSplit:maxConvos
        });

        let inSpaceParticipants=[];
        let outOfSpaceParticipants=[];
        let participantSpacesChanged=false;
        for (const sid in spaces) {
            spaces[sid].forEach(pid=>{
                inSpaceParticipants.push(pid);
                //detect if participant space is different from before
                if(!participantSpacesChanged && (sc.lastAutoSplitSpaces[sid] == undefined || !sc.lastAutoSplitSpaces[sid].includes(pid))){
                    participantSpacesChanged=true;
                }
            });
        }
        console.log(`In space participants`,inSpaceParticipants);
        outOfSpaceParticipants=allParticipants.filter(id=>!inSpaceParticipants.includes(id));
        console.log(`out of space participants`,outOfSpaceParticipants);
        try {
            CONV_STORAGE.userSpaceStatusChanged('users_moving',null);
            if(localConvos.length){
                //we have to create some spaces
                try {
                    let spacesCreated=await sc.createConversations(localConvos,makeSpacesPrivate);
                    console.log("spaces created response",spacesCreated);
                        if(spacesCreated!=false && typeof spacesCreated.data == "object"){
                            Object.keys(spacesCreated.data).map(lcid => {
                                dataToSend.push({
                                    participants: spaces[lcid],
                                    ...spacesCreated.data[lcid]
                                });
                                sc.lastAutoSplitSpaces[spacesCreated.data[lcid].id]=spaces[lcid];
                                sc.sendNewConversationMessage(spacesCreated.data[lcid]);
                            });
                        console.log("Local spaces created..........")
                        }else{
                            console.error("error creating local spaces");
                            sc.enableModalButton();
                            return;
                        }
                } catch (error) {
                    console.error("error creating local spaces",error);
                }

            }
            if(existingConvos.length){
                //add existing convos to send
                existingConvos.map(spaceId=>{
                    if(CONV_STORAGE.conversations[spaceId]){
                        dataToSend.push({
                            participants: spaces[spaceId],
                            id:spaceId,
                            conv_type:CONV_STORAGE.conversations[spaceId].conv_type,
                            name:CONV_STORAGE.conversations[spaceId].name,
                            room_id:CONV_STORAGE.conversations[spaceId].room_id,
                            is_private: makeSpacesPrivate
                        });
                        sc.lastAutoSplitSpaces[spaceId]=spaces[spaceId];
                    }
                });
                console.log("Existing spaces added for send.....");
            }
            console.log("Data to send", dataToSend);
            //share recent split to other users
            clearTimeout(this.countDownTimeout);
            sc.shareLastSplitData();

            sc.sendSplitToConversationsInvite(dataToSend, inviteType, setLockFocus, masterVolume, warn, notificationSound,{recurring:recurring});
            if(recurring){
                this.countDownTimeout = setTimeout(() => {
                    sc.startRecurringSplit();
                }, timeout);
            }
            if(outOfSpaceParticipants.length){
                socket.sendSplitOutOfSpace(outOfSpaceParticipants,inviteType,setLockFocus,masterVolume,"automatic", warn, notificationSound,{recurring:true,spacesChanged:participantSpacesChanged});
            }
            if(this.automaticTimerComponent.isShown()){
                if(this.countDownTimeout){clearTimeout(this.countDownTimeout)}
                this.countDownTimeout = setTimeout(() => {
                    this.automaticTimerComponent.sendStartTimerCommand();
                }, timeout);
            }
            if(setLockFocus && !lockFocus.locked){
                lockFocus.startLockFocus();
            }else if(!setLockFocus && lockFocus.locked){
                lockFocus.stopLockFocus();
            }
            if(lockMasterVolume){
                Video.lockMasterVolume.disableMasterVolume(true);
            }else if(!lockMasterVolume && Video.lockMasterVolume.masterVolumeDisabled){
                Video.lockMasterVolume.enableMasterVolume(true);
            }
            sc.hideModal();
        } catch (error) {
            sc.enableModalButton();
        }

    };


    getExistingPinnedSpaceIds(){
        return Object.values(CONV_STORAGE.conversations).filter(c=>c.conv_type=="pinned").map(c=>c.id);
    };

    //end card 822
    manualSplitToConvos() {
        var sc = this;
        if (!sc.validateManualSplit()) {
            sc.enableModalButton();
            return
        }
        if(this.manualSplitTimerComponent.isShown()){
            if(!this.manualSplitTimerComponent.validateTimer()){
                sc.enableModalButton();
                return;
            }
        }
        //end card 674
        let dataToSend = [];
        let inviteType = 'force';
        let setLockFocus = $('#split-manual-lock-focus-checkbox').is(":checked") ? true : false;
        let masterVolume = inviteType == "force" && sc.setBackgroundNoiseManual ? 0 : 0.05;
        let makeSpacesPrivate = sc.manualMakePrivateCheckbox.is(":checked");
        let warn = sc.warnNotificationManual;
        let notificationSound = sc.playNotificationManual;
        let participantSpacesChanged=false;
        console.log("Master volume overwrite for manual spaces",masterVolume)
        let toCreate=[];
        let lockMasterVolume = masterVolume == 0 && sc.lockMasterVolumeManual.is(':checked');

        sc.setNewManualPreferences({
            lockFocus:setLockFocus,
            inviteType:inviteType,
            muteChatter:masterVolume===0 ? true : false,
            warnNotification:warn,
            playNotificationSound:notificationSound,
            makeSpacesPrivate:makeSpacesPrivate,
            lockMasterVolume: lockMasterVolume,
            timer: {
                showTimer: sc.manualSplitTimerComponent.isShown() ? true : false,
                showNotification: sc.manualSplitTimerComponent.showTimesUpInput.is(':checked'),
                notificationShowTimeMinutes: sc.manualSplitTimerComponent.notificationTimeInputMinutes.val(),
                notificationShowTimeSeconds: sc.manualSplitTimerComponent.notificationTimeInputSeconds.val(),
                playNotificationSound: sc.manualSplitTimerComponent.playSoundCountdownInput.is(':checked'),
                minutes:sc.manualSplitTimerComponent.min,
                seconds:sc.manualSplitTimerComponent.sec
            }
        });

        console.log("manual convos",sc.manualConversations);


        Object.values(sc.manualConversations).map(convo=>{
            if(!convo.existing){
                if(!participantSpacesChanged){
                    participantSpacesChanged=true;
                }
                toCreate.push({
                    local_id:convo.id,
                    name:convo.name,
                    is_private:convo.is_private
                });
            }else if(convo.existing && !participantSpacesChanged){
                if(!CONV_STORAGE.conversations[convo.conversation_id]){
                    //this space has been deleted recreate
                    convo.existing=false;
                    toCreate.push({
                        local_id:convo.id,
                        name:convo.name,
                        is_private:convo.is_private
                    });
                }
                if(convo.participants && convo.participants.length){
                    convo.participants.forEach(pid=>{
                        if(sc.lastAutoSplitSpaces[convo.conversation_id] == undefined || !sc.lastAutoSplitSpaces[convo.conversation_id].includes(pid)){
                            participantSpacesChanged=true;
                        }
                    })
                }
            }else if(convo.existing){
                if(!CONV_STORAGE.conversations[convo.conversation_id]){
                    //this space has been deleted recreate
                    convo.existing=false;
                    toCreate.push({
                        local_id:convo.id,
                        name:convo.name,
                        is_private:convo.is_private
                    });
                }
            }
        });
        console.log("recurring kino is ",sc.recurring);
        if(sc.recurring && sc.recurring.runingTimerId){
            sc.stopRecurringSplit();
        }
        if(onStage.isActive()){
            onStage.sendEndOnStage();
        }
        console.warn("Participants left out of conversations",sc.getNonConvoParticipnats());
        console.log("lastAutoSplitSpaces",sc.lastAutoSplitSpaces);
        let outOfSpacesParticipants=sc.getNonConvoParticipnats();
        CONV_STORAGE.userSpaceStatusChanged('users_moving',null);
        clearTimeout(this.countDownTimeout);
        if(toCreate.length){
                sc.createConversations(toCreate).then(res => {
                    console.log(typeof res.data);
                if (typeof res.data == "object") {
                    console.log("Success", res.data);

                    dataToSend=sc.socketBuildObject(res.data);
                    sc.sendSplitToConversationsInvite(dataToSend, inviteType, setLockFocus, masterVolume, warn, notificationSound);
                    if(outOfSpacesParticipants.length){
                        socket.sendSplitOutOfSpace(outOfSpacesParticipants,inviteType,setLockFocus, masterVolume,"manual", warn, notificationSound,{spacesChanged:participantSpacesChanged});
                    }
                    if(this.manualSplitTimerComponent.isShown()){
                        let timeout = warn ? 10000 : 0;
                        this.countDownTimeout = setTimeout(() => {
                            this.manualSplitTimerComponent.sendStartTimerCommand();
                        }, timeout);
                    }
                    //begin card 539 #19
                    /*room.setLocalParticipantProperty('split_spaces_locked',setLockFocus ? JSON.stringify({
                        from_id:room.myUserId()
                    }): null);
                    room.setLocalParticipantProperty('can_unlock_spaces',setLockFocus ? true : null);*/
                    //end card 539 #19
                    if(setLockFocus && !lockFocus.locked){
                        lockFocus.startLockFocus();
                    }else if(!setLockFocus && lockFocus.locked){
                        lockFocus.stopLockFocus();
                    }
                } else {
                    sc.enableModalButton();
                }
                if(lockMasterVolume){
                    Video.lockMasterVolume.disableMasterVolume(true);
                }else if(!lockMasterVolume && Video.lockMasterVolume.masterVolumeDisabled){
                    Video.lockMasterVolume.enableMasterVolume(true);
                }
                sc.hideModal();
            }).catch(err => {
                sc.enableModalButton();
            });
        }else if(Object.keys(sc.manualConversations).length > toCreate.length){

            dataToSend=sc.socketBuildObject({});
            sc.sendSplitToConversationsInvite(dataToSend, inviteType, setLockFocus, masterVolume, warn, notificationSound);
            if(outOfSpacesParticipants.length){
                socket.sendSplitOutOfSpace(outOfSpacesParticipants,inviteType,setLockFocus,masterVolume,"manual",warn,notificationSound,{spacesChanged:participantSpacesChanged});
            }
            if(this.manualSplitTimerComponent.isShown()){
                let timeout = warn ? 10000 : 0;
                if(this.countDownTimeout){clearTimeout(this.countDownTimeout)}
                this.countDownTimeout = setTimeout(() => {
                    this.manualSplitTimerComponent.sendStartTimerCommand();
                }, timeout);
            }
            //begin card 539 #19
            /*room.setLocalParticipantProperty('split_spaces_locked',setLockFocus ? JSON.stringify({
                from_id:room.myUserId()
            }): null);
            room.setLocalParticipantProperty('can_unlock_spaces',setLockFocus ? true : null);*/
            //end card 539 #19
            if(setLockFocus && !lockFocus.locked){
                lockFocus.startLockFocus();
            }else if(!setLockFocus && lockFocus.locked){
                lockFocus.stopLockFocus();
            }
            sc.enableModalButton();
            if(lockMasterVolume){
                Video.lockMasterVolume.disableMasterVolume(true);
            }else if(!lockMasterVolume && Video.lockMasterVolume.masterVolumeDisabled){
                Video.lockMasterVolume.enableMasterVolume(true);
            }
            sc.hideModal();
        }

    };

    manualTabClickHandler(e) {
        let sc = this;
        $('.modal-conv').addClass('manual');
        sc.lobbyContainerManually.empty()
        sc.modalRenderParticipantsSection();
        sc.enableModalButton();
        console.log("manual split tab")
        sc.enableModalButton();
        sc.orderSpacesToTop();
        document.getElementById('conversation-list').scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(() => {
            sc.startEfss();
        }, 500);
    }

    automaticTabClickHandler(e) {
        let sc = this;
        $('.modal-conv').removeClass('manual');
        sc.validateSplit(sc.autoConversationsInput.val());
        console.log('automatic split')
        // if($('.errors div div div i').hasClass('fa-exclamation-triangle')){
        //     sc.disableModalButton(false)
        // }
    }

    socketBuildObject(newConvos){
        let sc=this;

        let data=[];
        Object.values(sc.manualConversations).map(conv=>{
            if(conv.existing){
                data.push({
                    participants:conv.participants,
                    id:conv.conversation_id,
                    name:conv.name,
                    conv_type:"pinned",
                    is_private: conv.is_private
                });
                sc.lastAutoSplitSpaces[conv.conversation_id]=conv.participants;
                conv.participants.forEach(pid=>{
                    sc.recentUserSpace[pid]=conv.conversation_id;
                });
            }
        });
        Object.keys(newConvos).map(lcid => {
            data.push({
                participants: sc.manualConversations[lcid].participants,
                ...newConvos[lcid]
            })
            sc.lastAutoSplitSpaces[newConvos[lcid].id]=sc.manualConversations[lcid].participants;
            sc.manualConversations[lcid].participants.forEach(pid=>{
                sc.recentUserSpace[pid]=newConvos[lcid].id;
            });
            sc.sendNewConversationMessage(newConvos[lcid]);
        });
        //share split with other users
        sc.shareLastSplitData();
        return data;
    };
    createMergedSpacesArray(spacesToCreate,inBackground=false){
        let existingSpaces = this.getExistingPinnedSpaceIds();
        let excludedSpaces = this.getExcludedSpaceIds(inBackground);
        let availableSpaces = existingSpaces.filter(cid=>!excludedSpaces.includes(parseInt(cid)));
        console.log("Available spaces to create ",availableSpaces);
        let returnSpaces=[];
        if(availableSpaces.length >= spacesToCreate){
            //we have enough spaces to split
            return this.randomizeArray(availableSpaces).slice(0,spacesToCreate);

        }else if(availableSpaces.length<=spacesToCreate){

            if(availableSpaces.length){
                returnSpaces=availableSpaces;
            }

            for (let index=availableSpaces.length; index < spacesToCreate; index++) {
                returnSpaces.push('conversation_' + index);
            }
            return this.randomizeArray(returnSpaces);
        }
    };
    getExcludedSpaceIds(inBackground=false){
        let excludedSpaces=[];
        let excludedIds=inBackground && this.recurring ? this.recurring.excludeParticipants : this.selectedExcludedParticipants
        console.log("getting excluded spaces from excluded participants",excludedIds);
        excludedIds.forEach(pid=>{
            let cid=CONV_STORAGE.isOnConversation(pid);
            if(cid && !excludedSpaces.includes(cid)){
                excludedSpaces.push(parseInt(cid));
            }
        });
        console.log("Found excluded spaces from excluded participants",excludedSpaces);
        return excludedSpaces;
    };
    //this function pick a space for a user
    splitUserToSpace(user_id,max_users,sortSpaces=false){
        let wasWithUsers=[];//get users that user_id was with recently
        if(this.recentUserSpace[user_id] && this.lastAutoSplitSpaces[this.recentUserSpace[user_id]]){
            wasWithUsers=this.lastAutoSplitSpaces[this.recentUserSpace[user_id]];
        }
        let currentSpaceIds=this.sortedSpaces(); // Object.keys(this.currentSplitedSpaces);
        for (let i = 0; i < currentSpaceIds.length; i++) {
            const space_id=currentSpaceIds[i];

            if(this.currentSplitedSpaces[space_id].length==max_users){
                //skip this space if has reached maximum of users
                console.log("Maximum participants reached for space "+space_id);
                continue;
            }
            const hasPreviousUsers=this.currentSplitedSpaces[space_id].filter(u=>wasWithUsers.includes(u));
            console.log("hasPreviousUsers",hasPreviousUsers);
            if(hasPreviousUsers.length==0){
                if(sortSpaces){
                    let sorted=this.sortedSpaces();
                    if(this.currentSplitedSpaces[sorted[0]].length < (max_users-1) && sorted[0] != space_id
                    && this.currentSplitedSpaces[space_id].length >= (max_users-1)){
                        console.log(`Found a matching space ${space_id} for participant ${user_id}`)
                        console.log(`Space ${sorted[0]} has less than needed users to split and Space ${space_id} has ${this.currentSplitedSpaces[space_id].length} users`)
                        return false;
                    }
                }
                this.currentSplitedSpaces[space_id].push(user_id);
                this.recentUserSpace[user_id]=space_id;
                console.log("User "+user_id+" moved to space "+space_id);
                return space_id;
            }
        }
        console.error("No space found for participant"+user_id);
        return false;
    };

    splitArray(array, pieces,inBackground=false) {
        var sf = this;
        let shuffled = sf.randomizeArray(array);
        shuffled=sf.sortRegisteredOnTop(shuffled);
        let shuffledSpaces=this.createMergedSpacesArray(pieces,inBackground);
        console.warn("Merged spaces with existing",shuffledSpaces);
        console.log("Shuffled", shuffled);
        let itemsPerArray = Math.floor(shuffled.length / pieces);

        //reset current spil to spaces
        this.currentSplitedSpaces={};
        shuffledSpaces.forEach(sid=>{
            this.currentSplitedSpaces[sid]=[];
        });
        let addedUsers=[];
        for (let ux = 0; ux < shuffled.length; ux++) {
            const user_id = shuffled[ux];
            if(this.splitUserToSpace(user_id,itemsPerArray)===false){
                //if user found no space
            }else{
               addedUsers.push(user_id);
            }
        }

        if (shuffled.length > addedUsers.length) {
            let nonAssigned = shuffled.filter(id=>!addedUsers.includes(id));
            console.log("Users left without a space", nonAssigned);
            for (let ux = 0; ux < nonAssigned.length; ux++) {
                const user_id = nonAssigned[ux];
                if(this.splitUserToSpace(user_id,itemsPerArray+1,true)===false){
                    //if user found no space
                    console.log("Last chance to find a space, user "+user_id+" left without a space, we are going to add this user to a random space",this.sortedSpaces());
                    let randomSpaces = this.sortedSpaces();
                    let SpaceId=randomSpaces[0] ? randomSpaces[0] : false;
                    if(this.currentSplitedSpaces[SpaceId]){
                        // console.log("Moving participant "+user_id+" to space",SpaceId);
                        this.currentSplitedSpaces[SpaceId].push(user_id);
                        this.recentUserSpace[user_id]=SpaceId;
                    }

                }
            }
        }
        //this.sortedSpaces();

        return this.currentSplitedSpaces;
    };

    sortedSpaces(){
       return Object.keys(this.currentSplitedSpaces).sort((a,b)=>this.currentSplitedSpaces[a].length - this.currentSplitedSpaces[b].length);
    };
    sortRegisteredOnTop(input){
        //find out registered
        let registered=[];
        input.forEach(pid=>{
            try {
               if(pid==room.myUserId()){
                    if(HOST ==1 || ROLE == 'moderator'){
                        registered.push(pid);
                    }
                    return;
                }
                let prole=room.getParticipantById(pid).getProperty('role');
                let ismember= room.getParticipantById(pid).getProperty('member');
                if(ismember == true || prole == "moderator" || prole == "host"){
                    registered.push(pid);
                }
            } catch (error) {}
        });
        console.log("registered participants",registered);
        let nonRegistered=input.filter(pid=>!registered.includes(pid));
        return registered.concat(nonRegistered);
    };

    async createConversations(localIds,makePrivate=false) {
        try {
            let res = await axios.post(convertPath('/conversation/bulk/create'), {
                localIds: localIds,
                room_id: room.getName(),
                from_id: 'moderator',
                make_private:makePrivate
            },await electronConfig());
            return res;
        } catch (error) {
            return false;
        }

    };

    sendNewConversationMessage(conversation) {
        var sc = this;
        if (conversation.id) {
            conversation['participants'] = [];
            socket.sendBroadcastMessage({
                eventName: "NewPinnedConversation",
                data: conversation,
                created_from: "splitToConversations",
                room_id: room.getName()
            });
            CONV_STORAGE.newConversation(conversation);
            // CONV_STORAGE.appendConversation(conversation);

        }
    };

    sendSplitToConversationsInvite(data, type, lockfocus, masterVolume=0.05, showNotif=false, playNotificationSound=false,extraData={}) {
        //var sc=this;
        socket.sendSplitToConversationsMessage(data, type, lockfocus, masterVolume, showNotif, playNotificationSound,extraData);
    };

    addConversations() {
        // console.log(CONV_STORAGE.conversations.values());
        let conversations = Object.keys(CONV_STORAGE.conversations).map((key) => {
            return CONV_STORAGE.conversations[key]
        });
        this.manualMakePrivateCheckbox.prop('checked',false);
        // console.log("adding conversations",conversations)
        conversations.forEach(element => {
            //if(element.conv_type=="pinned"){ //card 760
               this.newConversationElement({
                    name: element.name,
                    conv_type:element.conv_type,//card 760
                    participants: element.participants,//.filter(p=>p!=room.myUserId()),
                    id: element.id,
                    is_private: element.is_private
                }, "db");
            //}//card 760

        })
    }

    setFocusLock(locked){
        this.focusLocked=locked;
        /*if(locked) {
            $('#make-conversation-private').addClass('d-none')
        } else {
            $('#make-conversation-private').removeClass('d-none')
        }*/
        console.log('_focus_locked', this.focusLocked)
    };

    unlockFocus(from,name){
        //this.setFocusLock(false);
        //this.hideUnlockFocusButton();
        //this.sendUnlockFocusCommand(from,name);
        //room.setLocalParticipantProperty('split_spaces_locked',null);
        //room.setLocalParticipantProperty('can_unlock_spaces',null);
    };

    sendUnlockFocusCommand(from,name) {
        socket.sendBroadcastMessage({
            eventName: "unlockSplitConvosFocus",
            data: {
                participant: from,
                name:name,
                room_id: room.getName()
            },
            room_id:room.getName()
        });
    }

    // showLockFocusNotification() {
    //     console.log('_focus_is_locked', this.focusLocked)
    //     Video.notifications.find(`.stealFocusNotification-notification-${room.myUserId()}`).remove();
    //     Video.showNotification(this.focusedIcon,`Focus is currently locked by moderators`,'stealFocusNotification',room.myUserId());
    // }

    unlockFocusEvent(message){
        console.log('_focus_unlocked')
        //this.setFocusLock(false);
        //this.hideUnlockFocusButton();
        //room.setLocalParticipantProperty('split_spaces_locked',null);
        //room.setLocalParticipantProperty('can_unlock_spaces',null);
    };


    randomizeArray(array) {
        return array.sort(() => Math.random() - 0.5);
    };

    showNumberOfParticipants() {
        this.numberOfParticipants.html(`Move ${this.getKinoParticipantIds(true).length} participants into:&nbsp;`);
    };

    makeConversationEditable(conversation) {
        let maxLength = 25;
        console.log(CONV_STORAGE.conversations);
        if(!conversation) return;

        console.log(conversation)
        console.log(conversation.expand)
        conversation.oldName = conversation.expand.html();
        let conversationNameInput=$("<input/>",{
            type:"text",
            class:"form-control input-sm",
            value:conversation.oldName,         //card id 726
            maxlength: maxLength,                      //card id 726
            style: `height: 30px`
        });
        //card id 726 begin
        conversationNameInput.on('input paste', function(e){
            // console.log('Characters: ', this.value.length);
            if(this.value.length > maxLength){
                this.value = this.value.substring(0, maxLength);
            }
        });
        //card id 726 end
        conversation.expand.html(conversationNameInput);
        conversationNameInput.focus();
        let length = conversationNameInput.val().length;
        conversationNameInput[0].setSelectionRange(length, length);
        conversation.editConversationBtn.css('display', 'none')
        conversation.removeConversationBtn.css('display','none')
        conversation.actionButtons.css('display', 'flex')
    }

    cancelNameChange (conversation, id) {
        conversation.expand.html(conversation.oldName)
        console.log(conversation, id)
        conversation.actionButtons.css('display', 'none');
        conversation.editConversationBtn.css('display', 'flex');
        conversation.removeConversationBtn.css('display','flex')
    };

    saveName (conversation, id) {
        let name=conversation.expand.find('input').val();
        if(name.trim().length == 0){
            this.cancelNameChange(conversation,id);
            return
        }
        conversation.actionButtons.css('display', 'none');
        conversation.editConversationBtn.css('display', 'flex');
        conversation.removeConversationBtn.css('display','flex')
        conversation.expand.html(name);
        this.manualConversations[conversation.id].name = name;

        if(conversation.existing){
            this.setName(id,name);
        }
    };

    async setName (id, name) {
        CONV_STORAGE.conversations[id].name = name;
        CONV_STORAGE.conversations[id].spaceName.html(name);
        //begin card 800
        axios.post(convertPath(`/conversation/name/${id}`),{
            name: name
        }, await electronConfig()).then(res=>{
            if (res.data.success === true) {
                //send websocket notification
                socket.sendConversationNameChanged(id, CONV_STORAGE.room_id, name);
                return;
            }
        }).catch(err=>{
            console.error("update name error",error);
        });
        //end card 800
        CONV_STORAGE.updateBanner();
    };
    toggleSpacePrivate(tmpID,isPrivate){
        try {
            this.manualConversations[tmpID].is_private=isPrivate;
            this.manualConversations[tmpID].togglePrivateButton.html(isPrivate ? `<i class="fa fa-lock"></i>` : `<i class="fa fa-unlock"></i>`);
            if(isPrivate){
                this.manualConversations[tmpID].togglePrivateButton.addClass('button-is-private');
            }else{
                this.manualConversations[tmpID].togglePrivateButton.removeClass('button-is-private');
            }
            this.manualConversations[tmpID].togglePrivateButton.attr('title',isPrivate ? `Make not private` : `Make private`);
            // this.manualConversations[tmpID].togglePrivateButton.tooltip('hide');
            this.shouldEnableMakePrivateCheckbox();
        } catch (error) {

        }
    };

    makeAllSpacesPrivate(isPrivate){
        Object.keys(this.manualConversations).forEach(ID=>{
            this.toggleSpacePrivate(ID,isPrivate);
        });
    };

    newConversationElement(preMade = null, status = "event") {
        $('#container-split-convo-placeholder').css('display', 'none');
        var sc = this;
        const ID = Math.floor(Math.random() * new Date().getTime());
        const INDEX = Object.keys(sc.manualConversations).length + 1;
        const newConvo = {};
        const makePrivateChecked=sc.manualMakePrivateCheckbox.is(':checked');

        // console.log("Make all spaces private checked",makePrivateChecked)
        newConvo.expandBody = $("<div/>", {
            class: 'expand-body-convo',
            html: '<i class="fas fa-caret-down"></i>',
        }).on('click', (e) =>{
            if(newConvo.body.hasClass('expanded')){
                newConvo.body.removeClass('expanded');
            }else{
                newConvo.body.addClass('expanded')
            }
        });

        newConvo.body = $("<div/>", {
            'conversation-id':ID,
            class: `card-body card-body-modified dropzone-conversation-${ID}`,
            html: [newConvo.expandBody]
        }).on('mouseenter blur focusout', () =>{
            // console.log('children inside: ', $(`.dropzone-conversation-${ID} .user-added-split-convo`).length);
            if($(`.dropzone-conversation-${ID} .user-added-split-convo`).length > 4){
                newConvo.expandBody.addClass('visible');
            }else{
                newConvo.expandBody.removeClass('visible');
                newConvo.body.removeClass('expanded');
            }
        });

        newConvo.id = ID
        newConvo.existing=preMade && preMade.id ? true :false;
        newConvo.is_private = preMade ? preMade.is_private ? true : false : makePrivateChecked;
        console.log("Is private",newConvo.is_private);
        newConvo.conv_type=preMade && preMade.conv_type ? preMade.conv_type : 'pinned';//card 760
        newConvo.conversation_id=preMade ? preMade.id : null;
        newConvo.name = (status == "db") ? preMade.name : `Space ${INDEX}`;
        newConvo.participants = [];//(status == "db") ? preMade.participants : [];
        newConvo.listCollapse = $("<div/>", {
            id: `listCollapse${ID}`,
            class: "listCollapse",
            'aria-labelledby': `heading${ID}`,
            // 'data-parent': "#accordion",
            html: newConvo.body
        }).on('click', (e) => {
            e.stopPropagation()
            e.preventDefault()
            console.log($(e.currentTarget))
        });

        newConvo.saveNameBtn = $("<span/>", {
            class: "ml-1",
            type: "button",
            html: `<i class="fas fa-check"></i>`,
        }).on('click', () => {
            sc.saveName(newConvo, ID)
        });
        newConvo.cancelSaveNameBtn = $("<span/>", {
            class: "ml-1",
            type: "button",
            html: `<i class="fas fa-times"></i>`
        }).on('click', () => {
            sc.cancelNameChange(newConvo, ID)
        })
        newConvo.actionButtons = $("<div/>", {
            class: "name-actions-convo-manual",
            html: [newConvo.saveNameBtn, newConvo.cancelSaveNameBtn]
        })
        newConvo.expand = $("<div/>", {
            // class: "btn",
            'data-toggle': `listCollapse`,
            'data-target': `#listCollapse${ID}`,
            'aria-expanded': "false",
            'aria-controls': `listCollapse${ID}`,
            // card id 726 begin
            style: `
                width: 100%;
                max-width: 140px;
                overflow: hidden;
                text-align: left;
                padding: 5px;
                text-overflow: ellipsis;
                `,
            // card id 726 end
            html: [(status == "db") ? preMade.name : `Space ${INDEX}` ]
        });
        newConvo.convoExpandCont = $("<div/>", {
            class: 'mb-0',
            style: `width:100%`,
            html: [newConvo.expand],
            id: "edit-convo-name-field"
        });
        /*newConvo.addParticipantBtn = $("<div/>", {
            html: "Add Participant",
            type: "button",
            id: `dropdown_${ID}`,
            // 'data-toggle': "dropdown",
            // 'aria-haspopup': "true",
            // 'aria-expanded': "false",
            class: "btn add-button-split-convo d-flex"
        }).on('click', function() {
            //add participant
            sc.createParticipantsPopup(ID);
        });*/
        newConvo.removeConversationBtn = $("<div />", {
            html: `<i class="fas fa-times" style="font-size:16px"></i>`,//card 760
            type: "button",
            class: `btn btn-sm add-button-split-convo`,
            style: `display: flex`,
            title: 'Remove',
            'data-toggle': 'tooltip',
            'data-placement': 'top'
        }).on('click', e => {
            if(this.manualConversations[ID].existing){
                if(CONV_STORAGE.conversations[preMade.id].conv_type=='pinned'){
                   CONV_STORAGE.unPinConversation(preMade.id);
                }
            }

            newConvo.card.remove();
            delete this.manualConversations[newConvo.id];

            //begin card 539
            sc.lobbyContainerManually.empty();
            this.modalRenderParticipantsSection();
            //end card 539
            this.addHelpTextIfNoConvo();
        })
        newConvo.editConversationBtn = $("<button/>", {
            html: `<i class="fas fa-pen"></i>`,
            type: "button",
            class: `btn add-button-split-convo`,
            title: 'Edit space name',
            'data-toggle': 'tooltip',
            'data-placement': 'top'
        }).on('click', () => {
            this.makeConversationEditable(newConvo)
        })
        // newConvo.dropDown = $("<div/>", {
        //     class: 'dropdown-menu ',
        //     'aria-labelledby': `dropdown_${ID}`,
        //     html: `<h6 class="dropdown-header">Participants</h6>`
        // });
        newConvo.togglePrivateButton = $("<button/>", {
            html: newConvo.is_private ? `<i class="fa fa-lock"></i>` : `<i class="fa fa-unlock"></i>`,
            type: "button",
            class: `btn add-button-split-convo make-private-button ${!permissions.hasPrivateSpaces() ? 'feature-disabled' : ''} ${newConvo.is_private ? 'button-is-private' : ''}`,
            title:permissions.hasPrivateSpaces() ? `Make ${ newConvo.is_private ? 'not private' : 'private'}` : 'This feature is disabled in this workspace.',
            'data-toggle': 'tooltip',
            'data-placement': 'top'
        }).on('click', () => {
            if(!permissions.hasPrivateSpaces()){return}
            sc.toggleSpacePrivate(ID,!newConvo.is_private);
        });

        newConvo.addParticipantDrop = $("<div/>", {
            class: "btn-group",
            html: [newConvo.editConversationBtn,newConvo.togglePrivateButton,newConvo.removeConversationBtn/*, newConvo.addParticipantBtn , newConvo.dropDown */]     // card 539
        })

        newConvo.nameGropup = $("<div/>", {
            class: "name-group d-flex align-items-center flex-grow-1",
            html: [newConvo.convoExpandCont]
        })

        newConvo.ationButtonsContainer = $("<div />", {
            class: "",
            html: [newConvo.actionButtons/*, newConvo.editConversationBtn*/]
        })

        newConvo.nameContainer = $("<div />", {
            class: "name-container d-flex align-items-center",
            html: [newConvo.nameGropup, newConvo.ationButtonsContainer],
            style: `justify-content: space-between; width: 100%`
        })

        newConvo.header = $("<div/>", {
            class: "card-header card-header-split-convo",
            id: `heading${ID}`,
            html: [newConvo.nameContainer, newConvo.addParticipantDrop]
        });

        newConvo.card = $("<div/>", {
            class: `card`,
            id: `card-id-${ID}`,
            html: [newConvo.header, newConvo.listCollapse]
        });

        sc.manualConversations[ID] = newConvo;
        newConvo.card.appendTo(sc.conversationsContainer);
        sc.shouldEnableMakePrivateCheckbox();
        this.makeConversationDropZone(`.dropzone-conversation-${ID}`);
        //newConvo.listCollapse.listCollapse();
        this.cancelNameChange(newConvo, preMade ? preMade.id : ID)
        if(newConvo.participants.length==0 && (status == "db") && preMade){
            console.log("Adding existing participants",preMade.participants);
            this.addSelectedToConvo(ID,preMade.participants);
        }
        document.getElementById('conversation-list').scrollIntoView({ behavior: 'smooth', block: 'end' });
    };

    shouldEnableMakePrivateCheckbox(){
        let allSpaces=Object.keys(this.manualConversations).length;
        let privateSpaces=0;
        Object.values(this.manualConversations).forEach(s=>{
            if(s.is_private){
                privateSpaces++;
            }
        });
        console.trace("Should make spaces private?")
        if(privateSpaces > 0 && privateSpaces==allSpaces){
            this.manualMakePrivateCheckbox.prop('checked',true);
        }else{
            this.manualMakePrivateCheckbox.prop('checked',false);
        }
    };
    getKinoParticipantIds(automatic=false) {
        if(!room){return []}
        let pids=Object.keys(Video.videos);
            pids.unshift(room.myUserId());

        if(automatic){
            pids=pids.filter(p=>!this.selectedExcludedParticipants.includes(p));
        }
        return pids;
    };

    resetSelections() {
        var sc = this;
        sc.conversationsContainer.html('');
        sc.manualConversations = {};
        if(onStage.isActive()){
            console.log("Stage View options",onStage.options);
            sc.lockFocusAuto.prop("checked", onStage.options.lockFocusOriginalState);
            sc.lockFocusManual.prop("checked", onStage.options.lockFocusOriginalState);
        }else{
            sc.lockFocusAuto.prop("checked", lockFocus.locked);
            sc.lockFocusManual.prop("checked", lockFocus.locked);
        }
        sc.manualMakePrivateCheckbox.prop('checked',false);
        //repeat options
        // sc.autoRepeatCheckBox.prop('checked', false);
        // $('#repeat-split-container').css("opacity",'0.4')
        // $('#repeat-split-container').find('input').attr('readonly',true);
        // sc.repeatMinutesSecondsLabel.html('minutes');
        // this.repeatOccurMinutes.val('02')
        // this.repeatOccurSeconds.val('00');
        // this.repeatRunEndsInput.val(2);

    };
    addSelectedToConvo(cid, participants) {
        var sc = this;
        //filter dublicates
        participants=participants.filter(p=>!sc.manualConversations[cid].participants.includes(p));
        sc.manualConversations[cid].participants = sc.manualConversations[cid].participants.concat(...participants);
        //add html
        participants.map(pid => {

            if(Video.videos[pid]===undefined && pid != room.myUserId()){return}
            let container = $('<div/>', {
                class: `user-added-split-convo pid-${pid} draggable-participant draggable-participant-${pid}`,
                'participant-id':pid,
                'conversation-id':cid
            });
            let removeBtn = $('<button/>', {
                class: `user-remove-split-convo`,
                html: "Remove"
            }).on('click', function() {
                container.remove();
                sc.manualConversations[cid].participants = sc.manualConversations[cid].participants.filter(p => p != pid);
            });
            // container.html([pname, removeBtn]);                  // card 539
            let videoTrack = pid != room.myUserId() ? Video.getParticipantVideo(pid) : getLocalMainKinoTrack();
            let video_element = $('<video />', {
                autoplay: 1,
                class: `user-video ${pid == room.myUserId() ? cameraOptionsPreferences.camera_flip ? 'flipVideoX' : '' : ''}`
            });
            let user_name = $('<div />', {
                class: 'user-name',
                html: `<span>${sc.getParticipantNameById(pid)}</span>`
            })
            console.log('elme_vide', videoTrack)
            if(videoTrack) {
                video_element[0].srcObject = videoTrack.stream;
            }
            //begin card 760
            let thumb='';
            let currentCid=CONV_STORAGE.isOnConversation(pid);
            const videoMuted = pid != room.myUserId() ? Video.videos[pid].isVideoMuted() : Video.localVideo.cameraMutedByMe;
            if(Video.videos[pid] && Video.videos[pid].thumbnail && currentCid!=CONV_STORAGE.myConversation){
                  thumb=new Image();
                  thumb.src=Video.videos[pid].thumbnail;
                  thumb.classList.add("no-video-thumbnail");

            }
            const noCameraCircle=$('<div/>',{
                class: 'no-cam-layer-background mt-3',
                html: Video.noCameraIcon
            });
            const noCameraLayerThumb=$("<div/>",{
                class:`no-camera-spaces-thumb ${ videoMuted ? '' : 'd-none'}`,
                html:[noCameraCircle]
            });

            //end card 760
            container.html([user_name, video_element,noCameraLayerThumb, thumb]);  // card 760
            sc.manualConversations[cid].body.prepend(container);
            interact(`.draggable-participant-${pid}`)
            .draggable({
                inertia: true,
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: document.querySelector('#pills-manual'),
                        endOnly: true,
                    })
                ],
                autoScroll: true,
                // dragMoveListener from the dragging demo above
                // card 539
                listeners: {
                    start: this.startDraggingConvoParticipant.bind(this),
                    move: this.dragMoveListener.bind(this)                }
                // end card 539
            });
        });
        // sc.manualConversations[cid].listCollapse();
    };

    setManualTabMessage(message) {
        $("#manual-convo-message").html(message);
    };

    showNotification(user_name, participant_id) {
        var sf = this;
        Video.showNotification(sf.focusedIcon, `${user_name} is on stage`, 'stealFocusNotification', participant_id);
    };
    disableModalButton(spining=true) {
        var sc = this;
        sc.runSplitBtn.attr('disabled', 'disabled');
        spining && sc.runSplitBtn.html(`<i class="fas fa-circle-notch fa-spin"></i> SET SPACES`);
    };
    enableModalButton() {
        var sc = this;
        sc.runSplitBtn.removeAttr('disabled');
        sc.runSplitBtn.html("SET SPACES");
    };

    addHelpTextIfNoConvo(){
        if($('#conversation-list').is(':empty')){                                       // card 539
            $('#container-split-convo-placeholder').css('display', 'flex');
        }else{
            $('#container-split-convo-placeholder').css('display', 'none');
        }
    };
   //card id 539
    getNonConvoParticipnats(){
        let pids = this.getKinoParticipantIds();
        let notInConvo = [];
        let inconvo = [];
        Object.values(this.manualConversations).map(data=>{
            inconvo = inconvo.concat(...data.participants);
        });
        console.log("manual spaces",this.manualConversations);
        console.log("in convo participants", inconvo);
        notInConvo=pids.filter(pid =>!inconvo.includes(pid));
        return notInConvo;
    };
    getParticipantNameById(id){
       try {
           if(id==room.myUserId()){
               return MY_NAME+" (me)";
           }
        return room.getParticipantById(id).getDisplayName();
       } catch (error) {
            return 'Kino Guest'
       }
    }
    modalRenderParticipantsSection(){
        let sc = this;
        console.error("render participants section")
        sc.lobbyContainerManually.empty();
        let participantIds=sc.getNonConvoParticipnats();
        participantIds.map(pid=>{
            sc.addNonSelectedParticipant(pid);
        });
    };

    updateVideoStream(pid) {
        if(!this.enabled){return}
        if(!this.modal.hasClass('show') && !this.modal.hasClass("minimized-modal")){return}
        console.log("Called updateVideoStream method on Spaces Manager ,participant id = " + pid)
        let participantTile = $(`#pills-manual`).find(`.draggable-participant-${pid} video`);
        // console.log("Found videos", participantTile)
        $.each(participantTile, (i, video) => {
            try {
                let vtrack=pid==room.myUserId() ? getLocalMainKinoTrack() : Video.getParticipantVideo(pid);
                if(vtrack){
                    video.srcObject=vtrack.stream;
                }
            } catch (error) {
                console.log(error)
            }
        });
    }

    addNonSelectedParticipant(pid){
        let sc = this;
        console.trace("Add to non selected participant",pid);
        sc.lobbyContainerManually.find(`.draggable-participant-${pid}`).remove();
        let pname=this.getParticipantNameById(pid);
        let participantName=$('<span/>',{
            class: "participant-name",
            html: `<span>${pname}</span>`
        });
        let participantVideo=document.createElement('video');
        participantVideo.autoplay=1;
        let videoTrack=pid != room.myUserId() ? Video.getParticipantVideo(pid) : getLocalMainKinoTrack();
        participantVideo.setAttribute('pid', pid)
        participantVideo.setAttribute('class', pid == room.myUserId() ? cameraOptionsPreferences.camera_flip ? 'flipVideoX' : '' : '');
        if(videoTrack){
            participantVideo.srcObject=videoTrack.stream;
        }
        //begin card 760
        let thumb='';
        let currentCid=CONV_STORAGE.isOnConversation(pid);
        const videoMuted = pid != room.myUserId() ? Video.videos[pid].isVideoMuted() : Video.localVideo.cameraMutedByMe;
        if(Video.videos[pid] && Video.videos[pid].thumbnail && currentCid!=CONV_STORAGE.myConversation){
              thumb=new Image();
              thumb.src=Video.videos[pid].thumbnail;
              thumb.classList.add("no-video-thumbnail");

        }

        const noCameraCircle=$('<div/>',{
            class: 'no-cam-layer-background mt-3',
            html: Video.noCameraIcon
        });
        const noCameraLayerThumb=$("<div/>",{
            class:`no-camera-spaces-thumb ${ videoMuted ? '' : 'd-none'}`,
            html:[noCameraCircle]
        });

        //participantVideo.srcObject=
        let participantbox=$('<li/>',{
            class:`participant-item draggable-participant draggable-participant-${pid}`,
            html:[participantName,participantVideo,noCameraLayerThumb,thumb],//card 760
            'participant-id':pid
        });

        //append with order
        var sortedList = new Array();
	    sc.lobbyContainerManually.find("li .participant-name span").each(function(i, item) {
	            sortedList.push($(this).html().toLowerCase());
	    })
	    var initialLength = sortedList.length;
	    sortedList.push(pname.toLowerCase());
	    sortedList.sort();
        // console.log(pname+ "Sorted participants in lobby names",sortedList)
	    var i = $.inArray(pname.toLowerCase(), sortedList);
	    //  console.log("After participant add sorted list index="+i,sortedList);
	    if(i == initialLength) {
            sc.lobbyContainerManually.append(participantbox);
	    } else if(i==0){
            // console.log("Prepending participant")
            sc.lobbyContainerManually.prepend(participantbox);
        }else {
            // console.log("adding after ",sc.lobbyContainerManually.find("li")[i])
	        $(sc.lobbyContainerManually.find("li")[i]).before(participantbox);
	    }


        //sc.lobbyContainerManually.append(participantbox);
        //make draggable
        interact(`.draggable-participant-${pid}`)
        .draggable({
            inertia: true,
            modifiers: [
                interact.modifiers.restrictRect({
                    restriction: document.querySelector('#pills-manual'),
                    endOnly: true,
                  })
            ],
            autoScroll: true,
            // dragMoveListener from the dragging demo above
            // card 359
            listeners: {
                start:this.startDraggingParticipant.bind(this),
                move: this.dragMoveListener.bind(this),
            }
            // end card 359
        });
    };
    dragMoveListener(event){
        // console.log("moving participant",event);
        var target = event.target
        // keep the dragged position in the data-x/data-y attributes
        var x = (parseFloat(target.getAttribute('data-x')) || 0 ) + event.dx
        var y = (parseFloat(target.getAttribute('data-y')) || 0 ) + event.dy

        // translate the element
        target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

        // update the posiion attributes
        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
        Object.assign(event.target.dataset, { x, y })
    }
    // card 539
    dragStopListener(event) {
        $('.accordion-container-split-convo .scrollUp').addClass('d-none')
        $('.accordion-container-split-convo .scrollDown').addClass('d-none')
    }
    // end card 539
    initializeDragDrop(){
        let sc=this;
        interact('.participant-drop-zone').dropzone({
            // only accept elements matching this CSS selector
            accept: '.draggable-participant',
            // Require a 75% element overlap for a drop to be possible
            overlap: 0.05,

            // listen for drop related events:

            ondropactivate: function (event) {
              // add active dropzone feedback
              //   console.log("drop is active")
              event.target.classList.add('drop-active')

            },
            ondragenter: function (event) {
              var draggableElement = event.relatedTarget
              var dropzoneElement = event.target
              // console.log("drag enter",event.target);
              // feedback the possibility of a drop
              dropzoneElement.classList.add('drop-target')
              //draggableElement.classList.add('can-drop')
              //draggableElement.textContent = 'Dragged in'
            },
            ondragleave: function (event) {
              // remove the drop feedback style
              event.target.classList.remove('drop-target')
              //event.relatedTarget.classList.remove('can-drop')
              //event.relatedTarget.textContent = 'Dragged out'
            },
            ondrop: this.participantDroppedOutOfConversation.bind(this),
            ondropdeactivate: (event) =>  { // card 359
                // console.log("drop deactive participant zone");
                // console.log(event); // card 359
                $("#spl-participant-list").removeClass('drop-target')
                console.log("element classname",event.relatedTarget.className);
                this.dragStopListener()
                if(event.relatedTarget && !event.relatedTarget.dropped && event.relatedTarget.nodeName=="LI"){
                    let pid=event.relatedTarget.getAttribute('participant-id');
                    if(sc.lobbyContainerManually.find(`.draggable-participant-${pid}`).length){
                        event.relatedTarget.remove();
                        return
                    }
                    let appendIndex=parseInt(event.relatedTarget.parentIndex);
                    if(appendIndex==0 || event.target.children.length==0){
                        event.target.prepend(event.relatedTarget);
                    }else if(appendIndex >= event.target.children.length){
                        event.target.append(event.relatedTarget);
                    }else{
                        Array.from(event.target.children).forEach((element,index)=>{
                            if(index==appendIndex){
                                event.target.insertBefore(event.relatedTarget, element.nextSibling);
                            }
                        });
                    }

                    event.relatedTarget.style.transform = 'translate(0px, 0px)';
                    event.relatedTarget.removeAttribute('data-x');
                    event.relatedTarget.removeAttribute('data-y');
                }
            }
          });


    };
    makeConversationDropZone(element_id){
        //interact.dynamicDrop(true);
        interact(element_id).dropzone({
            // only accept elements matching this CSS selector
            accept: '.draggable-participant',
            // Require a 75% element overlap for a drop to be possible
            overlap: 0.05,

            // listen for drop related events:

            ondropactivate: function (event) {
              // add active dropzone feedback
            //   console.log("drop is active")
              event.target.classList.add('drop-active')
            },
            ondragenter: (event) => {
                console.log("ondragenter " + element_id)
                var draggableElement = event.relatedTarget
                var dropzoneElement = event.target
                // console.log("drag enter",event.target);
                // feedback the possibility of a drop
                dropzoneElement.classList.add('drop-target')
                //draggableElement.classList.add('can-drop')
                //draggableElement.textContent = 'Dragged in'
            },
            ondragleave: function (event) {
              // remove the drop feedback style
              event.target.classList.remove('drop-target')
              $("#conversation-list").find(element_id).removeClass('drop-target')
              //event.relatedTarget.classList.remove('can-drop')
              //event.relatedTarget.textContent = 'Dragged out'
            },
            ondrop: (event) =>{
                this.participantDroppedInConversation(event)
            },
            ondropdeactivate:  (event) => { // card 359
                console.log("ondropdeactivate " + element_id)
                this.dragStopListener() // card 359
                // console.log('drop deactivate conversation ', event);
                // console.log(`drop deactive space ID: ${event.target.getAttribute('conversation-id')} ,participant space ID:${event.relatedTarget.getAttribute('conversation-id')}`,event);
                let containerConversation=event.target.getAttribute('conversation-id');//card 539
                let participantConversation=event.relatedTarget.getAttribute('conversation-id');//card 539
                if(event.relatedTarget && !event.relatedTarget.dropped && event.relatedTarget.nodeName=="DIV" && (!event.currentTarget || event.currentTarget.nodeName=="DIV") && containerConversation==participantConversation){//card 539
                    let appendIndex=parseInt(event.relatedTarget.parentIndex);
                    if(appendIndex==0 || event.target.children.length==0){
                        event.target.prepend(event.relatedTarget);
                    }else if(appendIndex >= event.target.children.length){
                        event.target.append(event.relatedTarget);
                    }else{
                        Array.from(event.target.children).forEach((element,index)=>{
                            if(index==appendIndex){
                                event.target.insertBefore(event.relatedTarget, element.nextSibling);
                            }
                        });
                    }

                    event.relatedTarget.style.transform = 'translate(0px, 0px)';
                    event.relatedTarget.removeAttribute('data-x');
                    event.relatedTarget.removeAttribute('data-y');
                }
                $("#conversation-list").find(element_id).removeClass('drop-target')
            }
          });
          interact.dynamicDrop(true);
    };

    participantDroppedInConversation(event){
        let sc = this;
        console.log("on-drop",event.relatedTarget);
        // console.log('container',event.target);
        let participantId=event.relatedTarget.getAttribute('participant-id');
        let oldConversationId=event.relatedTarget.getAttribute('conversation-id');
        let conversationId=event.target.getAttribute('conversation-id');
        console.log(`Participant dropped to space ${conversationId} old ${oldConversationId}`)
        if(participantId && conversationId && conversationId != oldConversationId){
            if(oldConversationId){
                //begin card 760
                if(this.manualConversations[oldConversationId].existing && this.manualConversations[oldConversationId].conv_type!='pinned'){
                    CONV_STORAGE.pinConversation(this.manualConversations[oldConversationId].conversation_id);
                    this.manualConversations[oldConversationId].conv_type='pinned';
                }
                //end card 760
                this.manualConversations[oldConversationId].participants = this.manualConversations[oldConversationId].participants.filter(p => p != participantId);
                console.log("Old conversation",this.manualConversations[oldConversationId].participants);
            }

            this.addSelectedToConvo(conversationId,[participantId]);
            console.log("new space",this.manualConversations[conversationId].participants);
            event.relatedTarget.remove();
            event.relatedTarget.dropped=true;
            sc.startEfss();
            //sc.orderSpacesToTop();
        }else{
            event.relatedTarget.dropped=false;
            console.log("not adding as new participant");
        }
    };
    participantDroppedOutOfConversation(event){
        console.log("element dropped",event.relatedTarget);
        //if(event.relatedTarget.)
        let participantId=event.relatedTarget.getAttribute('participant-id');
        let conversationId=event.relatedTarget.getAttribute('conversation-id');
        if(participantId && conversationId){
            this.addNonSelectedParticipant(participantId);
            event.relatedTarget.remove();
            event.relatedTarget.dropped=true;
            //begin card 760
            if(this.manualConversations[conversationId].existing && this.manualConversations[conversationId].conv_type!='pinned'){
                CONV_STORAGE.pinConversation(this.manualConversations[conversationId].conversation_id);
                this.manualConversations[conversationId].conv_type='pinned';
            }
            //end card 760
            this.manualConversations[conversationId].participants = this.manualConversations[conversationId].participants.filter(p => p != participantId);
            //this.orderSpacesToTop();
            this.startEfss();
        }
    };

    startDraggingParticipant(event){
        // console.log("started dragging",event);
        // card 539
        // console.log('_drag', $('#conversation-list').children().length)
        if($('#conversation-list').children().length > 4) {
            $('.accordion-container-split-convo .scrollUp').removeClass('d-none')
            $('.accordion-container-split-convo .scrollDown').removeClass('d-none')
        }
        // end card 539
        let dragContainer=$('#dragging-state-container').offset();
        // console.log(`Item dragging `,event.client);
        // console.log(`Dragging container`,dragContainer);
        let x=(event.rect.left-dragContainer.left)+(event.rect.width/2);//card 539 #9
        let y=event.rect.top-dragContainer.top;
        //var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
        //var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

        var parent = event.target.parentNode;
        // The equivalent of parent.children.indexOf(child)
        var index = Array.prototype.indexOf.call(parent.children, event.target);
        console.log("parent index is ",index);
        event.target.parentIndex=index;
        $(event.target).prependTo($('#dragging-state-container'));
         // translate the element
        event.target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'
        event.target.setAttribute('data-x', x)
        event.target.setAttribute('data-y', y)
          // update the position attributes
        Object.assign(event.target.dataset, { x, y })
    };
    startDraggingConvoParticipant(event){
        let dragContainer=$('#dragging-state-container').offset();
        if($('#conversation-list').children().length > 4) {
            $('.accordion-container-split-convo .scrollUp').removeClass('d-none')
            $('.accordion-container-split-convo .scrollDown').removeClass('d-none')
        }
        // console.log(`Item dragging `,event.client);
        // console.log(`Dragging container`,dragContainer);
        let x=(event.rect.left-dragContainer.left)+(event.rect.width/2);
        let y=event.rect.top-dragContainer.top;
        //var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
        //var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

        var parent = event.target.parentNode;
        // The equivalent of parent.children.indexOf(child)
        var index = Array.prototype.indexOf.call(parent.children, event.target);
        // console.log("parent index is ",index);
        event.target.parentIndex=index;
        $(event.target).prependTo($('#dragging-state-container'));
         // translate the element
        event.target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'
        event.target.setAttribute('data-x', x)
        event.target.setAttribute('data-y', y)
          // update the position attributes
        Object.assign(event.target.dataset, { x, y })
    }

    scrollContent(direction) {
        // console.log(`Scrolling ${direction}`)
        var amount = (direction === "up" ? "-=5" : "+=5");
        $("#conversation-list").parent().animate({
            scrollTop: amount
        }, 1 , 'linear' , e => {
            if (this.scrolling) {
                this.scrollContent(direction);
            }
        });
    }

    participantLeft(id){
        try {
            /*if(room){
                let participants=room.getParticipants();
                if(participants){
                    let can_unlock=participants.filter(p=>p.getProperty('can_unlock_spaces') && p.getId() != id);
                    console.log("Participants that can unlock spaces",can_unlock);
                    if(can_unlock.length==0 && HOST==0 && ROLE!="moderator"){
                        console.warn("Unlocking spaces");
                        this.setFocusLock(false);
                    }
                }
            }*/
            this.onParticipantRemoved(id);//card 760
        } catch (error) {

        }
    };

    sendMeOutOfSpace(message){

        console.error(message)
        console.error(CONV_STORAGE.myConversation)
        console.log(CONV_STORAGE.masterVolumeOverwrite);
        try {
            if(CONV_STORAGE.myConversation && message.data.splitType=="manual"){
                CONV_STORAGE.showNotification(Video.conversationIcon, "JOIN_SPLIT_CONVERSATION_FORCE", {...message.data,conversation_id:null});
            }else if(message.data.inviteType=="force"){
                if(!CONV_STORAGE.myConversation && message.data.splitType=="manual" && message.data.data.spacesChanged){
                    CONV_STORAGE.userSpaceStatusChanged('users_moving',null);
                    setTimeout(() => {
                        CONV_STORAGE.userSpaceStatusChanged('users_moved',null);
                    }, 1500);
                }
                this.splitSpacesSettingsHandler({...message.data,conversation_id:null});
            }
        } catch (error) {
            console.error("Moving out of space error",error);
        }
    };
    //card id 539 begin
    showErrorMessage(message,information=false) {
        let sp = this;
        return `
            <div class="alert mb-0 mt-3" role="alert">
                <div class="row align-items-center">
                    <div class="col-auto font-md pr-0 ${information ? 'black-color' : 'red-color'}">
                        ${information ? '<i class="fas fa-info-circle h5 m-0" style="font-weight: 900"></i>' : sp.errorIcon}
                    </div>
                    <div class="col ${information ? 'black-color' : 'red-color'} px-2">
                        <p class='m-0'>${message}</p>
                    </div>
                </div>
            </div>
        `
    }
    //card id 539 end
    //begin card 760
    updatePrivacyThumbnail(pid){
        try {
            console.log("update privacy thumbnail");
            if(!this.enabled){return}
            if(!this.modal.hasClass('show') && !this.modal.hasClass("minimized-modal")){return}
            if(!Video || !Video.videos[pid]){return}
            let participantBoxes=$('#pills-manual').find(`.draggable-participant-${pid}`);
            console.log("found participant box",participantBoxes);
            console.log('stored thumbnail is',Video.videos[pid].thumbnail);
            let cid=CONV_STORAGE.isOnConversation(pid);
            if(cid==CONV_STORAGE.myConversation && Video.videos[pid].thumbnail){
                $.each(participantBoxes,(i,box)=>{
                    $(box).find('.no-video-thumbnail').remove();
                    let videoTrack = Video.getParticipantVideo(pid);
                    if(videoTrack){
                        $(box).find('video')[0].srcObject=videoTrack.stream;
                    }
                });
                return;
            }

            $.each(participantBoxes,(i,box)=>{
                if(!Video.videos[pid].thumbnail){
                    $(box).find('.no-video-thumbnail').remove();
                    let videoTrack = Video.getParticipantVideo(pid);
                    console.log("Got video track",videoTrack);
                    console.log('Video element is',$(box).find('video'));
                    if(videoTrack){
                        $(box).find('video')[0].srcObject=videoTrack.stream;
                    }
                    return;
                }
              let thumbnailExist=$(box).find('.no-video-thumbnail');
              if(thumbnailExist.length){
                thumbnailExist.attr('src',Video.videos[pid].thumbnail);
              }else{
                  let thumb=new Image();
                  thumb.src=Video.videos[pid].thumbnail;
                  thumb.classList.add("no-video-thumbnail");
                  $(box).append(thumb);
              }
            });

        } catch (error) {
            console.error('error updating video after privacy chnage',error)
        }
    };

    onParticipantJoined(pid){
        // if(!this.enabled || !$("#splitToConvo").hasClass('show')){return}
        if(this.enabled || this.modal.hasClass('show') || this.modal.hasClass('minimized-modal')){
            console.log("On participant joined method called on spaces manager")
            this.showNumberOfParticipants();
            if($('#pills-manual-tab').hasClass('active')){
                this.modalRenderParticipantsSection();
            }else if($('#pills-automatic-tab').hasClass('active')){
                this.validateSplit(this.autoConversationsInput.val());
                if(this.excludeSearchResults.hasClass('open')){
                    this.listSearchExludeParticipants(this.excludeSearchInput.val());
                }
            }
        }
    };
    onParticipantRemoved(pid){
        // if(!this.enabled || !$("#splitToConvo").hasClass('show')){return}
        if(this.enabled || this.modal.hasClass('show') || this.modal.hasClass('minimized-modal')){
            this.showNumberOfParticipants();
            if($('#pills-manual-tab').hasClass('active')){
                let participantIds=this.getNonConvoParticipnats();
                if(participantIds.includes(pid)){
                    this.modalRenderParticipantsSection();
                }else{
                    Object.keys(this.manualConversations).map(cid=>{
                        if(this.manualConversations[cid].participants){
                            this.manualConversations[cid].participants = this.manualConversations[cid].participants.filter(p => p != pid);
                        }
                    });
                    $('#pills-manual').find(`.draggable-participant-${pid}`).remove();
                }
            }else if($('#pills-automatic-tab').hasClass('active')){
                this.validateSplit(this.autoConversationsInput.val());
                if(this.excludeSearchResults.hasClass('open')){
                    this.listSearchExludeParticipants(this.excludeSearchInput.val());
                }
                if(this.selectedExcludedParticipants.includes(pid)){
                    this.selectedExcludedParticipants=this.selectedExcludedParticipants.filter(p=>p!=pid);
                    this.removeFromExcluded(pid);
                }
            }
        }
    };
    //end card 760

    /**
     * functions for exclude participant picker
     */

    addToExcluded(pid,name){
        console.log("function addToExcluded");
        this.selectedExcludedParticipants.push(pid);

        let selectedName=$("<div/>",{
            class:'selected-user-name',
            html: name.length >= 30 ? name.substring(0, 30) + "..." : name
        }),selectedRemove=$("<div/>",{
            class:'selected-user-remove',
            html:`<i class="fas fa-times" style="font-size:16px"></i>`
        }).on('click',(e)=>{
            e.stopPropagation();
            this.removeFromExcluded(pid);
        });
        let selectedUser=$("<div/>",{
            class:'selected-user-item',
            pid:pid,
            html:[selectedName,selectedRemove]
        });
        selectedUser.insertBefore(this.excludedParticipantsContainer.find('.search-item-container'));
        this.showNumberOfParticipants();
        this.validateSplit(this.autoConversationsInput.val());
        this.repositionExludeSearchList();
        if(this.excludeSearchResults.find('.current-list-item').length==0){
            this.hideExcludeSearchResults();
        }
    };

    removeFromExcluded(pid){
        this.selectedExcludedParticipants=this.selectedExcludedParticipants.filter(p=>p!=pid);
        this.excludedParticipantsContainer.find(`.selected-user-item[pid=${pid}]`).remove();
        if(this.excludeSearchResults.hasClass('open')){
            this.listSearchExludeParticipants(this.excludeSearchInput.val());
        }
        this.showNumberOfParticipants();
        this.validateSplit(this.autoConversationsInput.val());
        this.repositionExludeSearchList();
    }

    repositionExludeSearchList(){
        this.excludeSearchResults.css('top',this.excludedParticipantsContainer.outerHeight()+"px")
    }
    listSearchExludeParticipants(filter=""){
        let sp=this;
        let allParticipants=this.getKinoParticipantIds();
        let notSelected=allParticipants.filter(pid=>!this.selectedExcludedParticipants.includes(pid));
        this.excludeSearchResults.html('');
        if(notSelected.length==0){
            let listItem=$("<div/>",{
                class:"current-list-item justify-content-center",
                html:`No participants`
            });
            this.excludeSearchResults.append(listItem);
            return
        }
        notSelected.map(pid=>{
            let name="";
            let role="";
            if(pid==room.myUserId()){
                name=MY_NAME+" (me)";
                role=HOST==1 ? "host" : ROLE == "moderator" ? ROLE : '';
            }else{
                name=room.getParticipantById(pid).getDisplayName();
                role=room.getParticipantById(pid).getProperty('role');
                role=role!="none"? role :'';
            }
            if(name.toLowerCase().search(filter.toLowerCase())==-1 && filter!=""){return}
            let listItemName=$("<div/>",{
                class:"current-list-item-name",
                html: name.length >= 30 ? name.substring(0, 30) + "..." : name
            }),
            listItemRole=$("<div/>",{
                class:"current-list-item-role",
                html:role
            }),listItem=$("<div/>",{
                class:"current-list-item",
                html:[listItemName,listItemRole]
            });
            listItem.on('click',function(e){
                e.preventDefault();
                e.stopPropagation();
                console.log("add to excluded ",name);
                $(this).remove();
                sp.addToExcluded(pid,name);
            });
            this.excludeSearchResults.append(listItem);
            console.log(this.excludeSearchResults);
        });
    };

    showExludeSearchResults(){
        this.repositionExludeSearchList();
        this.excludeSearchResults.addClass('open').removeClass('d-none');
        this.listSearchExludeParticipants(this.excludeSearchInput.val());
    };

    hideExcludeSearchResults(){
        this.excludeSearchResults.removeClass('open').addClass('d-none');
        this.excludeSearchResults.html('');
    };

    handleSearchExludeInput(){
        this.excludedParticipantsContainer=$('#excluded-users-container');
        this.excludeSearchResults=$('#search-exclude-list-results');
        this.excludeSearchInput=$('#exlude-search-input');
        this.selectedExcludedParticipants=[];
        this.typingTimeout=0;
        this.modal.on('click',(e)=>{
            //console.log(e.target.className)
            if(e.target.className != 'selected-users-container form-control' && e.target.className !='selected-user-name'){
                this.hideExcludeSearchResults();
            }
        });
        this.excludeSearchInput.on('click',(e)=>{
            e.stopPropagation();
            this.showExludeSearchResults();
        }).on('keyup paste focus',()=>{
            clearTimeout(this.typingTimeout);
            this.typingTimeout=setTimeout(() => {
                this.listSearchExludeParticipants(this.excludeSearchInput.val());
            }, 100);
        });

    };

    resetExcludeInputs(){
        this.excludeSearchInput.val('');
        this.excludedParticipantsContainer.find('.selected-user-item').remove();
        this.selectedExcludedParticipants=[];
        this.hideExcludeSearchResults();
    }

    moveAllToLobby(){
        console.warn('moving all participants to split to spaces modal lobby');
        let sc = this;
        Object.keys(sc.manualConversations).map(cid=>{
            sc.manualConversations[cid].participants.forEach(pid => {
                sc.addNonSelectedParticipant(pid);
            })
            $(`.dropzone-conversation-${cid} .user-added-split-convo`).remove();
            sc.manualConversations[cid].participants = [];
        });

    }

    validateRepeatTimerInput(){
        let minutes=parseInt(this.repeatOccurMinutes.val());
        let seconds=parseInt(this.repeatOccurSeconds.val());
        let repeatRuns=parseInt(this.repeatRunEndsInput.val());
        console.log(`Repeat validation input time ${minutes}:${seconds}, repeat runs:${repeatRuns}`)
        if(isNaN(minutes) || isNaN(seconds)){
            this.automaticCalculated.html(`<div class='errors'>${this.showErrorMessage('Invalid repeat input time')}</div>`);
            return false;
        }
        let timerSeconds=this.durationToSeconds(minutes,seconds);
        if(timerSeconds < 30){
            this.automaticCalculated.html(`<div class='errors'>${this.showErrorMessage('Mimimum repeat occur time is 30 seconds')}</div>`);
            return false;
        }

        if(isNaN(repeatRuns) || repeatRuns <= 0){
            this.automaticCalculated.html(`<div class='errors'>${this.showErrorMessage('Invalid repeat end value')}</div>`);
            return false;
        }

        return true;
    };

    durationToSeconds(m,s){
        let minuteToSeconds=parseInt(m)*60;
        return minuteToSeconds+parseInt(s);
    };
    setRecurring(){
        let minutes=parseInt(this.repeatOccurMinutes.val());
        let seconds=parseInt(this.repeatOccurSeconds.val());
        let repeatRuns=parseInt(this.repeatRunEndsInput.val());
        let maxConvos = parseInt(this.autoConversationsInput.val());
        let excludeParticipants=this.selectedExcludedParticipants;
        let inviteType = 'force';
        let setLockFocus = $('#split-auto-lock-focus-checkbox').is(":checked") ? true : false;
        let makeSpacesPrivate = this.autoMakePrivateCheckbox.is(":checked");
        let masterVolume = inviteType == "force" && this.setBackgroundNoiseAutomatic ? 0 : 0.05;
        let warn = this.warnNotificationAuto;
        let notificationSound = this.playNotificationAuto;

        this.recurring={
            occurSeconds:this.durationToSeconds(minutes,seconds),
            repeatRuns:repeatRuns,
            currentRun:0,
            spaces:maxConvos,
            excludeParticipants:excludeParticipants,
            inviteType:inviteType,
            lockFocus:setLockFocus,
            makeSpacesPrivate:makeSpacesPrivate,
            masterVolume:masterVolume,
            runingTimerId:0,
            warn:warn,
            notificationSound:notificationSound
        };
        console.log("recurring object set",this.recurring);
    };

    async automaticSplitBackground() {
        let sc = this;
        if(!this.recurring){return}
        let maxConvos = sc.recurring.spaces;
        if (isNaN(maxConvos)) {
            sc.automaticCalculated.html(`<div class='errors'>${sc.showErrorMessage("Please specify a number of spaces to be created")}</div>`);
            sc.stopRecurringSplit();
            return;
        }
        if (!sc.validateSplit(maxConvos)) {
            sc.stopRecurringSplit();
            return;
        }

        let participants = sc.getKinoParticipantIdsBg(true);
        let allParticipants = sc.getKinoParticipantIds(false);
        let spaces = sc.splitArray(participants, maxConvos,true);
        console.log("Shared participants to spaces",spaces);
        let dataToSend = [];
        let inviteType = sc.recurring.inviteType;
        let setLockFocus = sc.recurring.lockFocus;
        let makeSpacesPrivate = sc.recurring.makeSpacesPrivate;
        let masterVolume = inviteType == "force" ? sc.recurring.masterVolume : 0.05;
        let warn = sc.recurring.warn;
        let timeout = warn ? 10000 : 0;
        let notificationSound =  sc.recurring.notificationSound;

        let localConvos=Object.keys(spaces).filter(spaceId=>spaceId.toString().startsWith('conversation'));
        let existingConvos=Object.keys(spaces).filter(spaceId=>!spaceId.toString().startsWith('conversation'));
        console.log(`Local spaces to create`,localConvos);
        console.log(`Existing spaces to send`,existingConvos);

        let inSpaceParticipants=[];
        let outOfSpaceParticipants=[];
        let participantSpacesChanged=false;
        for (const sid in spaces) {
            spaces[sid].forEach(pid=>{
                inSpaceParticipants.push(pid);
                //detect if participant space is different from before
                if(!participantSpacesChanged && (sc.lastAutoSplitSpaces[sid] == undefined || !sc.lastAutoSplitSpaces[sid].includes(pid))){
                    participantSpacesChanged=true;
                }
            });

        }
        console.log(`In space participants`,inSpaceParticipants);
        outOfSpaceParticipants=allParticipants.filter(id=>!inSpaceParticipants.includes(id));
        console.log(`out of space participants`,outOfSpaceParticipants);

        try {
            if(localConvos.length){
                //we have to create some spaces
                try {
                    let spacesCreated=await sc.createConversations(localConvos,makeSpacesPrivate);
                    console.log("spaces created response",spacesCreated);
                        if(spacesCreated!=false && typeof spacesCreated.data == "object"){
                            Object.keys(spacesCreated.data).map(lcid => {
                                dataToSend.push({
                                    participants: spaces[lcid],
                                    ...spacesCreated.data[lcid]
                                });
                                sc.lastAutoSplitSpaces[spacesCreated.data[lcid].id]=spaces[lcid];
                                sc.sendNewConversationMessage(spacesCreated.data[lcid]);
                            });
                        console.log("Local spaces created..........")
                        }else{
                            console.error("error creating local spaces");
                            sc.enableModalButton();
                            return;
                        }
                } catch (error) {
                    console.error("error creating local spaces",error);
                }

            }
            if(existingConvos.length){
                //add existing convos to send
                existingConvos.map(spaceId=>{
                    if(CONV_STORAGE.conversations[spaceId]){
                        dataToSend.push({
                            participants: spaces[spaceId],
                            id:spaceId,
                            conv_type:CONV_STORAGE.conversations[spaceId].conv_type,
                            name:CONV_STORAGE.conversations[spaceId].name,
                            room_id:CONV_STORAGE.conversations[spaceId].room_id,
                            is_private: makeSpacesPrivate
                        });
                        sc.lastAutoSplitSpaces[spaceId]=spaces[spaceId];
                    }
                });
                console.log("Existing spaces added for send.....");
            }
            console.log("Data to send", dataToSend);
            sc.shareLastSplitData()
            sc.sendSplitToConversationsInvite(dataToSend, inviteType, setLockFocus, masterVolume, warn, notificationSound,{recurring:true});
            if(outOfSpaceParticipants.length){
                socket.sendSplitOutOfSpace(outOfSpaceParticipants,inviteType,setLockFocus,masterVolume,"automatic", warn, notificationSound,{recurring:true,spacesChanged:participantSpacesChanged});
            }
            if(this.countDownTimeout){clearTimeout(this.countDownTimeout)}
            this.countDownTimeout = setTimeout(() => {
                sc.startRecurringSplit();
            }, timeout);
            if(setLockFocus && !lockFocus.locked){
                lockFocus.startLockFocus();
            }else if(!setLockFocus && lockFocus.locked){
                lockFocus.stopLockFocus();
            }
            //sc.hideModal();
        } catch (error) {
            //sc.enableModalButton();
            sc.stopRecurringSplit();
        }
    };
    async startRecurringSplit(){

        let timeNow=moment();
        let timerID=new Date().getTime();
        this.recurring.runingTimerId=timerID;
        kinoTimer.stopTimer(true);

        kinoTimer.activeTimersID = timerID;
        kinoTimer.myTimer=this.recurring.occurSeconds;
        let server=await kinoTimer.getServerTime(this.recurring.occurSeconds,1);
        this.recurring.runingTimerId=timerID;
        this.recurring.currentRun++;
        let options={
            hostStartDate:timeNow,
            seconds:this.recurring.occurSeconds,
            id: kinoTimer.activeTimersID,
            from_id:room.myUserId(),
            seconds_left: null,
            showCountDown: false,
            startCountDownAt : 0,
            playCountDownSound: false,
            recurring:true,
            serverStartTime: server.start,
            serverEndTime: server.end,
            current_round: this.recurring.currentRun,
            total_rounds: this.recurring.repeatRuns
        };
        kinoTimer.sendTimerMessage(options);
        kinoTimer.startTimer(options,"You");
        // console.error("Start recurring split");
    };
    stopRecurringSplit(){
        //stop timer and empty recurring object
        kinoTimer.stopTimer();
        this.recurring=null;
        // console.error("Stop recurring split");
    };
    onTimerEnded(){
        // console.error("On timer ended");
        if(!this.recurring){return}
        // console.log(`Timer ended currentRuns=${this.recurring.currentRun},repeatRuns=${this.recurring.repeatRuns}`);
        if(this.recurring.currentRun==this.recurring.repeatRuns){
            //move all to lobby
            this.moveParticipantsToLobby();
            this.stopRecurringSplit();
            return;
        }
        setTimeout(() => {
            this.automaticSplitBackground();
        }, 1000);
        //do next split or move all to lobby
        console.log("annother split here");
    };
    onTimerStoppedFromUser(timerID){
        if(this.recurring && this.recurring.runingTimerId == timerID){
            this.stopRecurringSplit();
        }
    };
    moveParticipantsToLobby(){
        let participants = this.getKinoParticipantIdsBg(true);
        if(participants.length){
            socket.sendSplitOutOfSpace(participants,"force",this.recurring.lockFocus,0.05,"manual", this.recurring.warn, this.recurring.notificationSound,{recurring:true});
        }
        //send reset volume for excludedParticipants
        if(this.recurring.excludeParticipants.length){
            socket.sendSplitOutOfSpace(this.recurring.excludeParticipants,"force",this.recurring.lockFocus,0.05,"automatic", this.recurring.warn, this.recurring.notificationSound,{recurring:true});
        }

    };
    getKinoParticipantIdsBg(automatic=false) {
        let pids=Object.keys(Video.videos);
            pids.unshift(room.myUserId());

        if(automatic){
            pids=pids.filter(p=>!this.recurring.excludeParticipants.includes(p));
        }
        return pids;
    };
    splitSpacesSettingsHandler(data){
        clearInterval(this.settignsCountDown);
        let initSettingsSeconds = data.showNotification ? 10 : 0;
            if(!data.showNotification){
                this.splitSpacesSettingsChanged(data);
            }else{
                this.settignsCountDown=setInterval(() => {
                    initSettingsSeconds--;
                    if(initSettingsSeconds<=0){
                         clearInterval(this.settignsCountDown);
                         this.splitSpacesSettingsChanged(data);
                    }
                }, 1000);
            }
    };
    showVolumeChangedTooltip(){
        let tooltip = new kinoTooltip("chatterBtnId","Chatter changed by moderator", {left: '20px', bottom: '120%'});
            tooltip.addTooltip();
            setTimeout(() => {
                tooltip.hideTooltip()
        }, 5000);
    }
    splitSpacesSettingsChanged(data){

        if(!data.conversation_id){
            permissions.isWorkspace && permissions.setSetting('mute_chatter',data.masterVolume==0)
            if(data.masterVolume==0){
                if(permissions.shouldMuteChatter()){
                    volumeManager.muteVolumeOverwrite=true;
                    this.showVolumeChangedTooltip();
                    volumeManager.muteChatter();
                    volumeManager.stateChangedWhileMuted=true;
                }
            }else if(data.masterVolume > 0 && volumeManager.muteVolumeOverwrite){
                volumeManager.muteVolumeOverwrite=false;
                this.showVolumeChangedTooltip();
                volumeManager.unMuteChatter();
            }
        }else{
            permissions.isWorkspace && permissions.setSetting('mute_chatter',data.masterVolume==0)
            if(data.conversation_id==CONV_STORAGE.myConversation && data.masterVolume == 0){
                if(permissions.shouldMuteChatter()){
                    console.log("Master volume",data.masterVolume)
                    console.log("Current master volume",parseFloat(volumeManager.masterVolume));
                    volumeManager.muteVolumeOverwrite = true;
                    if(parseFloat(volumeManager.masterVolume) != data.masterVolume){
                        this.showVolumeChangedTooltip();
                        if(data.masterVolume==0){
                            volumeManager.muteChatter();
                            volumeManager.stateChangedWhileMuted=true;
                        }else{
                            volumeManager.unMuteChatter();
                        }
                    }
                }
            }else if(data.conversation_id==CONV_STORAGE.myConversation && data.masterVolume > 0){
                if(volumeManager.muteVolumeOverwrite){
                    this.showVolumeChangedTooltip();
                    volumeManager.unMuteChatter();
                }
            }
        }
    };

    shareLastSplitData(){
        try {
           let userSpace={};
            for (const sid in this.lastAutoSplitSpaces) {
                this.lastAutoSplitSpaces[sid].forEach(pid=>{
                    userSpace[pid]=sid;
                });
            }
            room.broadcastEndpointMessage({
                recent_split: "user_spaces",
                userSpaces:userSpace
            });
        } catch (error) {
            console.error(error);
        }

    };

    setUserRecentSpace(user_id,space_id){
        this.recentUserSpace[user_id]=space_id;
        try {
            if(user_id==room.myUserId()){
                room.setLocalParticipantProperty('recent_space',space_id);
                return;
            }
            room.sendEndpointMessage(user_id,{
                recent_split: "user_space",
                user_id:user_id,
                space_id:space_id
            });
        } catch (error) {

        }
    };
    onUserRecentSpaceChanged(user_id,space_id){
        console.log(`Recent space changed for user ${user_id} to ${space_id}`);
        try {
            if(!space_id){
                //delete from recent spaces
                delete this.recentUserSpace[user_id];
                for (const sid in this.lastAutoSplitSpaces) {
                    this.lastAutoSplitSpaces[sid]=this.lastAutoSplitSpaces[sid].filter(p=>p!=user_id);
                }
                return;
            }
            if(this.recentUserSpace[user_id] && this.recentUserSpace[user_id] == space_id){
                return;
            }

            this.recentUserSpace[user_id]=space_id;
            if(!this.lastAutoSplitSpaces[space_id]){
                this.lastAutoSplitSpaces[space_id]=[];
            }
            let uniqueIds=this.lastAutoSplitSpaces[space_id].filter(p=>p!=user_id);
            uniqueIds.push(user_id);
            this.lastAutoSplitSpaces[space_id]=uniqueIds;
        } catch (error) {
            console.error(error);
        }
    }
    onRecentSplitEvent(user,message){
        try {
            let user_id=room.myUserId();
            let space=message.userSpaces[room.myUserId()] ? message.userSpaces[room.myUserId()] : false ;

            console.log(`Split event happened for ${user_id} to space  ${space}`);
            this.onUserRecentSpaceChanged(user_id,space);
            room.setLocalParticipantProperty('recent_space',space===false ? '' : space);

        } catch (error) {
            console.log(error)
        }
    }
    orderSpacesToTop(){
        let sc = this;
        Object.keys(sc.manualConversations).map(cid=>{
            // console.error(sc.manualConversations[cid].participants.length)
            //sc.manualConversations[cid].participants.forEach(pid => {
                if(sc.manualConversations[cid].participants.length == 0){
                    console.log("order space move to bottom",cid)
                    //sc.conversationsContainer.append($(`#card-id-${cid}`))
                    $(`#card-id-${cid}`).appendTo(sc.conversationsContainer);
                }
            //})
        });
    }

    resetModalUponExit(){
        let sc = this;
        // $(".modal-backdrop").remove();
        // sc.modal.removeClass('fadeOutDown fadeInUp');
        sc.lockFocusAuto.prop({checked: false});
        sc.lockFocusManual.prop({checked: false});
        sc.backgroundNoiseAutomatic.prop({'disabled': true, 'checked': false});
        sc.backgroundNoiseManual.prop({'disabled': true, 'checked': false}).trigger('change');
        sc.setBackgroundNoiseAutomatic = false;
        sc.setBackgroundNoiseManual = false;
        sc.warnNotificationAutoSwitch.prop({'disabled': true, 'checked': false});
        sc.warnNotificationManualSwitch.prop({'disabled': true, 'checked': false});
        sc.playNotificationAutoSwitch.prop({'disabled': true, 'checked': false});
        sc.playNotificationManualSwitch.prop({'disabled': true, 'checked': false});
        sc.playNotificationAutoVisibility.removeClass('height');
        sc.playNotificationManualVisibility.removeClass('height');
        sc.lockMasterVolumeAutomaticVisibility.removeClass('height');
        sc.lockMasterVolumeManualVisibility.removeClass('height');
        sc.warnNotificationAuto = false;
        sc.warnNotificationManual = false;
        sc.playNotificationAuto = false
        sc.playNotificationManual = false
        //begin card 539 #12
            stopMediaPlayers(sc.lobbyContainerManually);
            stopMediaPlayers($('#conversation-list .card'));
            sc.conversationsContainer.html('');
            sc.manualConversations={};
            sc.lobbyContainerManually.html('');
        //end card 539
        if(sc.lobbyContainerManually.hasClass('drop-target')){
            sc.lobbyContainerManually.removeClass('drop-target');
        }
    }


    onAutomaticPreferencesLoaded(){
        // let setLockFocus = $('#split-auto-lock-focus-checkbox').is(":checked") ? true : false;
        if(this.automaticPreferences['muteChatter']!==undefined){
            this.backgroundNoiseAutomatic.prop('checked',this.automaticPreferences.muteChatter).trigger('change');
        }else{
            this.backgroundNoiseAutomatic.prop('checked',false).trigger('change');
        }
        //show split notification
        if(this.automaticPreferences['warnNotification']!==undefined){
            this.warnNotificationAutoSwitch.prop('checked',this.automaticPreferences.warnNotification).trigger('change');
        }else{
            this.warnNotificationAutoSwitch.prop('checked',false).trigger('change');
        }
        //play notification sound
        if(this.automaticPreferences['playNotificationSound']!==undefined){
            this.playNotificationAutoSwitch.prop('checked',this.automaticPreferences.playNotificationSound).trigger('change');
        }else{
            this.playNotificationAutoSwitch.prop('checked',false).trigger('change');
        }

        if(this.automaticPreferences['convosToSplit'] !== undefined){
            this.autoConversationsInput.val(this.automaticPreferences.convosToSplit);
        }
        if(this.automaticPreferences['makeSpacesPrivate'] !== undefined){
            this.autoMakePrivateCheckbox.prop('checked',this.automaticPreferences['makeSpacesPrivate']).trigger('change');
        }
        if(this.automaticPreferences['lockMasterVolume']!==undefined){
            this.lockMasterVolumeAutomatic.prop('checked', this.automaticPreferences.lockMasterVolume);
        }

        //recurring
        if(this.automaticPreferences['recurring']!==undefined){
            if(!this.automaticPreferences.recurring){
                this.autoRepeatCheckBox.prop('checked',false).trigger('change');
            }else{
                this.autoRepeatCheckBox.prop('checked',true).trigger('change');
                this.repeatOccurMinutes.val(this.automaticPreferences.recurring.minutes).trigger('input');
                this.repeatOccurSeconds.val(this.automaticPreferences.recurring.seconds).trigger('input');
                this.repeatRunEndsInput.val(this.automaticPreferences.recurring.repeatRuns).trigger('input');
            }
        }else{
            this.autoRepeatCheckBox.prop('checked',false).trigger('change');
            this.repeatOccurMinutes.val('02').trigger('input');
            this.repeatOccurSeconds.val('00').trigger('input');
            this.repeatRunEndsInput.val(2).trigger('input');
        }

        //timer
        if(this.automaticPreferences['timer']!==undefined){
            if(!this.automaticPreferences.timer.showTimer){
                this.automaticTimerComponent.showTimerSwitchInput.prop('checked',false).trigger('change');
            }else{
                this.automaticTimerComponent.showTimerSwitchInput.prop('checked',true).trigger('change');
                this.automaticTimerComponent.showTimesUpInput.prop('checked',this.automaticPreferences.timer.showNotification).trigger('change');
                this.automaticTimerComponent.notificationTimeInput.val(this.automaticPreferences.timer.notificationShowTime);

                this.automaticTimerComponent.notificationTimeInputMinutes.val(this.automaticPreferences.timer.notificationShowTimeMinutes ? this.automaticPreferences.timer.notificationShowTimeMinutes : '00');
                this.automaticTimerComponent.notificationTimeInputSeconds.val(this.automaticPreferences.timer.notificationShowTimeSeconds ? this.automaticPreferences.timer.notificationShowTimeSeconds : '30');

                this.automaticTimerComponent.playSoundCountdownInput.prop('checked',this.automaticPreferences.timer.playNotificationSound).trigger('change');
                this.automaticTimerComponent.minutesInput.val(this.automaticPreferences.timer.minutes? this.automaticPreferences.timer.minutes : '00').trigger('input');
                this.automaticTimerComponent.secondsInput.val(this.automaticPreferences.timer.seconds? this.automaticPreferences.timer.seconds : '30').trigger('input');

            }
        }else{
            this.automaticTimerComponent.showTimerSwitchInput.prop('checked',false).trigger('change');
            this.automaticTimerComponent.showTimesUpInput.prop('checked',true).trigger('change');
            // this.automaticTimerComponent.notificationTimeInput.val(10);
            this.automaticTimerComponent.playSoundCountdownInput.prop('checked',true).trigger('change');
            this.automaticTimerComponent.minutesInput.val('00').trigger('input');
            this.automaticTimerComponent.secondsInput.val('30').trigger('input');
        }
    };

    onManualPreferencesLoaded(){
        if(this.manualPreferences['muteChatter']!==undefined){
            this.backgroundNoiseManual.prop('checked',this.manualPreferences.muteChatter).trigger('change');
        }else{
            this.backgroundNoiseManual.prop('checked',false).trigger('change');
        }
        //show split notification
        if(this.manualPreferences['warnNotification']!==undefined){
            this.warnNotificationManualSwitch.prop('checked',this.manualPreferences.warnNotification).trigger('change');
        }else{
            this.warnNotificationManualSwitch.prop('checked',false).trigger('change');
        }
        //play notification sound
        if(this.manualPreferences['playNotificationSound']!==undefined){
            this.playNotificationManualSwitch.prop('checked',this.manualPreferences.playNotificationSound).trigger('change');
        }else{
            this.playNotificationManualSwitch.prop('checked',false).trigger('change');
        }
        if(this.manualPreferences['lockMasterVolume']!==undefined){
            this.lockMasterVolumeManual.prop('checked', this.manualPreferences.lockMasterVolume);
        }

        // if(this.manualPreferences['makeSpacesPrivate'] !== undefined){
        //     this.manualMakePrivateCheckbox.prop('checked',this.manualPreferences['makeSpacesPrivate']).trigger('change');
        // }

        //timer
        if(this.manualPreferences['timer']!==undefined){
            if(!this.manualPreferences.timer.showTimer){
                this.manualSplitTimerComponent.showTimerSwitchInput.prop('checked',false).trigger('change');
            }else{
                this.manualSplitTimerComponent.showTimerSwitchInput.prop('checked',true).trigger('change');
                this.manualSplitTimerComponent.showTimesUpInput.prop('checked',this.manualPreferences.timer.showNotification).trigger('change');

                this.manualSplitTimerComponent.notificationTimeInputMinutes.val(this.manualPreferences.timer.notificationShowTimeMinutes ? this.manualPreferences.timer.notificationShowTimeMinutes : '00');
                this.manualSplitTimerComponent.notificationTimeInputSeconds.val(this.manualPreferences.timer.notificationShowTimeSeconds ? this.manualPreferences.timer.notificationShowTimeSeconds : '10');

                this.manualSplitTimerComponent.playSoundCountdownInput.prop('checked',this.manualPreferences.timer.playNotificationSound).trigger('change');
                this.manualSplitTimerComponent.minutesInput.val(this.manualPreferences.timer.minutes? this.manualPreferences.timer.minutes : '00').trigger('input');
                this.manualSplitTimerComponent.secondsInput.val(this.manualPreferences.timer.seconds? this.manualPreferences.timer.seconds : '30').trigger('input');
            }
        }else{
            this.manualSplitTimerComponent.showTimerSwitchInput.prop('checked',false).trigger('change');
            this.manualSplitTimerComponent.showTimesUpInput.prop('checked',true).trigger('change');
            // this.manualSplitTimerComponent.notificationTimeInput.val(10);
            this.manualSplitTimerComponent.playSoundCountdownInput.prop('checked',true).trigger('change');
            this.manualSplitTimerComponent.minutesInput.val('00').trigger('input');
            this.manualSplitTimerComponent.secondsInput.val('30').trigger('input');
        }
    };

    setNewAutomaticPreferences(preferences){
        this.automaticPreferences=preferences;
        userPreferences.storeNewPreferences('move_to_spaces_auto',preferences);
    };

    setNewManualPreferences(preferences){
        this.manualPreferences=preferences;
        userPreferences.storeNewPreferences('move_to_spaces_manual',preferences);
    };
    isModerator(){
        return ROLE=="moderator" || HOST == 1;
    };
    onUserRefresh(data){
        if(this.recurring){
            console.log("recurring split happening",)
            let excluded=this.recurring.excludeParticipants.find(pid=>pid==data.old_id);
            if(excluded){
                console.log(`Participant that refreshed was excluded on a recurring split`)
                let tempExcluded=this.recurring.excludeParticipants.filter(pid=>pid!=data.old_id);
                tempExcluded.push(data.new_id);
                this.recurring.excludeParticipants=tempExcluded;
            }
        }
    }

    videoMuteChanged(pid,muted){
        if(!this.enabled){return}
        if(!this.modal.hasClass('show') && !this.modal.hasClass("minimized-modal")){return}
        if(!Video || !Video.videos[pid]){return}

        let participantTile = $(`#pills-manual`).find(`.draggable-participant-${pid}`);
        $.each(participantTile, (i, tile) => {
            if(muted){
                $(tile).find('.no-camera-spaces-thumb').removeClass('d-none')
            }else{
                $(tile).find('.no-camera-spaces-thumb').addClass('d-none')
            }
        });
    }

    videoPauseChange(pid,paused){
        if(!this.enabled){return}
        if(!this.modal.hasClass('show') && !this.modal.hasClass("minimized-modal")){return}
        console.log("Called videoPauseChange on Spaces Manager, participant id = "+ pid)
        let participantTile = $(`#pills-manual`).find(`.draggable-participant-${pid} video`);
        $.each(participantTile, (i, video) => {
            try {
                if(paused){
                    video.pause();
                }else{
                    video.play();
                }
            } catch (error) {

            }
        });
    }

};
